import React, { Component } from 'react';
import { FixedSizeList as List } from 'react-window';
import styled from 'styled-components';
import {
  Row,
  Col,
  Button,
  PageHeader,
  Badge,
  Table,
  Input,
  Modal,
  Select,
  Spin,
  Divider,
  Card,
  Typography,
  Tabs,
  Upload,
  Checkbox,
  Space,
  InputNumber,
  Switch,
  Tag,
  Tooltip,
  Avatar,
  Collapse,
  FloatButton,
  Flex,
  Radio,
  Tour,
  DatePicker
} from 'antd';
import {
  CloseCircleFilled,
  CheckOutlined,
  CloseOutlined,
  BellOutlined,
  TeamOutlined,
  RedoOutlined,
  PlusCircleOutlined,
  PlusCircleFilled,
  CheckCircleOutlined,
  StopFilled,
  CloseCircleOutlined,
  RocketFilled,
  SearchOutlined,
  DeleteFilled,
  PlusOutlined,
  CaretRightOutlined,
  RightCircleFilled,
  ArrowLeftOutlined,
  CommentOutlined,
  CustomerServiceOutlined,
  SwapRightOutlined,
  InfoCircleFilled,
  EditFilled,
  AppstoreFilled,
  MinusCircleFilled
} from '@ant-design/icons';
import { ButtonSquare } from 'src/components/elements/Button';
import dropImage from 'src/static/icons/carImageUpload/placeholder.png';
import placeholderImg from 'src/static/no-image.png';
import Resizer from 'react-image-file-resizer';
import { Form } from '@ant-design/compatible';
import Notify from 'src/components/meta/Notification';
import Highlighter from 'react-highlight-words';
// import moment from 'moment';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const { Dragger } = Upload;
const { Search } = Input;
const { Title } = Typography;
const { Column } = Table;
const FormItem = Form.Item;
const { TextArea } = Input;
const { TabPane } = Tabs;

const { Option } = Select;
const Cards = styled(Card)`
  .ant-card .ant-card-body {
    padding-left: 0px !important;
    padding-bottom: 3em !important;
  }
`;
const ImageCards = styled(Card)`
  .ant-card .ant-card-body {
    display: none !important;
  }
`;
const modules = {
  toolbar: [
    // [{ header: '1' }, { header: '2' }, { font: [] }],
    // [{ size: [] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' }
    ],
    // ['link', 'image', 'video'],
    ['link'],
    ['clean']
  ],
  clipboard: {
    // toggle to add extra line breaks when mirrorsing HTML:
    matchVisual: true
  }
};
const StyledTable = styled(Table)`
  //   .ant-table-thead > tr > th {
  //     color: white !important;
  //     background: #1C1C1C !important;
  //   }
  // .ant-table-wrapper .ant-table-filter-trigger
  //   {
  //     margin-right:1em!important;
  //     color: white !important;
  //     background: #00b2067c !important;
  //   }
  //   .ant-table-tbody > tr > td {
  //     border-bottom: 1px solid #f0f0f0;
  //     transition: background 0.3s;
  //     font-weight: 500;
  //     color: #525f7f;
  //     font-size: 15px;
  //   }
`;
const StyledTableExpanded = styled(Table)`
  .ant-table-thead > tr > th {
    color: #525f7f !important;
    background: rgba(0, 0, 0, 0.02) !important;
  }
  .ant-table-wrapper .ant-table-filter-trigger {
    margin-right: 1em !important;
    color: white !important;
    background: #00b2067c !important;
  }
  .ant-table-tbody > tr > td {
    border-bottom: 1px solid #f0f0f0;
    transition: background 0.3s;
    font-weight: 500;
    color: #525f7f;
    font-size: 15px;
  }
`;
const StyledTabs = styled(Tabs)`
  .ant-tabs-top > .ant-tabs-nav::before,
  .ant-tabs-bottom > .ant-tabs-nav::before,
  .ant-tabs-top > div > .ant-tabs-nav::before,
  .ant-tabs-bottom > div > .ant-tabs-nav::before {
    position: absolute;
    right: 0;
    left: 0;
    border-bottom: 0px solid #f0f0f0 !important;
    content: '';
  }
`;

const StyledBadge = styled(Badge)`
  .ant-badge-status-dot {
    height: 0.6em !important;
    width: 0.6em !important;
  }
`;
const StyledInput = styled(Input)``;
const StyledInputNumber = styled(InputNumber)`
  // padding-left: 1.2em !important;
  // font-weight: 500 !important;
  // color: #525f7f !important;
  // font-size: 15px !important;
  // height: 47px !important;
  // border-right-width: 0px !important;
  //   box-shadow:none !important;
  // background-color: white!important;
  // background-image: none;
  // border: none;
  // border: 0px solid black !important;
  // border-bottom: 1px solid lightgrey !important;
  // border-radius: 0px;
  // color: black!important;
  // //box-shadow: rgba(0, 0, 0, 0.11) 2px 8px 13px 5px !important;
  // :placeholder {
  //   color: lightgrey !important;
  // }
  // :hover {
  //   border-color: red !important;
  //   border-right-width: 0px !important;
  //   box-shadow:none !important;
  // }
  // :active{
  //   border-color: red !important;
  //   border-right-width: 0px !important;
  //    box-shadow:none !important;

  // }
  // :focus{
  //   border-color: red !important;
  //   border-right-width: 0px !important;
  //    box-shadow:none !important;

  // }
  // }
`;
const StyledSelect = styled(Select)``;
function callback(key) {}

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

class AddStockForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedYear: dayjs().format('YYYY'),
      isRefunded:
        this.props.editStock && this.props.editStock.isRefunded ? true : false,
      // isRefunded: true,
      previewVisible: false,
      costVisible: false,
      roomsVisible: false,
      previewVisibleVariant: false,
      previewImage: '',
      previewTitle: '',
      fileList: [],
      mainProductImageAlt1: undefined,
      mainProductImage: undefined,
      mainProductImageAlt2: undefined,
      disabled: true,
      salesRows: [
        {
          id: 0,
          extraSales: undefined,
          saleRefund: undefined,
          saleCategory: undefined,
          saleComments: undefined
        }
      ],
      costRows: [
        {
          id: 0,
          costPrice: undefined,
          costPerPerson: undefined,
          costCategory: undefined,
          costComments: undefined
        }
      ],
      removedRows: [], // Track removed row IDs
      removedRowsCost: [], // Track removed row IDs

      // Track multiple salesRows in edit mode
      curDT: new Date().toLocaleString()
    };
    // this.handlePriceChange = this.handlePriceChange.bind(this);
    // this.handleSelectChange = this.handleSelectChange.bind(this);
  }

  handleAddRow = () => {
    this.setState(
      prevState => {
        const maxId = prevState.salesRows.length
          ? Math.max(...prevState.salesRows.map(row => row.id))
          : 0;

        const newRow = {
          id: maxId + 1,
          extraSales: undefined,
          saleCategory: undefined,
          saleComments: undefined,

          saleRefund: undefined
        };

        console.log('Adding Row:', newRow);
        console.log('Rows before adding:', prevState.salesRows);

        return {
          salesRows: [...prevState.salesRows, newRow]
        };
      },
      () => {
        console.log('Rows after adding:', this.state.salesRows);
      }
    );
  };

  handleRemoveRow = id => {
    this.setState(
      prevState => ({
        salesRows: prevState.salesRows.filter(row => row.id !== id),
        removedRows: [...prevState.removedRows, id] // Track removed salesRows
      }),
      () => {
        console.log('Rows after removal:', this.state.salesRows);
        console.log('Removed Rows:', this.state.removedRows);
      }
    );
  };

  handleAddRowCost = () => {
    this.setState(
      prevState => {
        const maxId = prevState.costRows.length
          ? Math.max(...prevState.costRows.map(row => row.id))
          : 0;

        const newRow = {
          id: maxId + 1,
          costPrice: undefined,
          costCategory: undefined,
          costComments: undefined,
          costPerPerson: undefined
        };

        console.log('Adding Row:', newRow);
        console.log('Rows before adding:', prevState.costRows);

        return {
          costRows: [...prevState.costRows, newRow]
        };
      },
      () => {
        console.log('Rows after adding:', this.state.costRows);
      }
    );
  };

  handleRemoveRowCost = id => {
    this.setState(
      prevState => ({
        costRows: prevState.costRows.filter(row => row.id !== id),
        removedRowsCost: [...prevState.removedRowsCost, id] // Track removed salesRows
      }),
      () => {
        console.log('Rows after removal:', this.state.costRows);
        console.log('Removed Rows:', this.state.removedRowsCost);
      }
    );
  };

  toggleDisabled = () => {
    this.setState({
      disabled: !this.state.disabled
    });
  };
  handleCancel = () =>
    this.setState({
      previewVisible: false,
      costVisible: false,
      roomsVisible: false,
      previewVisibleVariant: false
    });

  handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
      previewTitle:
        file.name || file.url.substring(file.url.lastIndexOf('/') + 1)
    });
  };
  handleChange = ({ fileList }) => this.setState({ fileList });

  selectisRefunded = checked => {
    this.setState({
      isRefunded: !checked ? false : true
    });
  };

  componentDidMount = () => {
    if (this.props.editStock) {
      const {
        cardSales = [],
        cashSales = [],
        extraSales = [],
        saleCategory = [],
        saleComments = [],
        saleRefund = [],
        costPrice = [],
        costCategory = [],
        costComments = [],
        costPerPerson = []
      } = this.props.editStock;

      // Filter out salesRows whose IDs are in removedRows
      const salesRows = extraSales
        .map((_, index) => ({
          id: index,
          cashSales: cashSales[index] ?? undefined,
          cardSales: cardSales[index] ?? undefined,
          extraSales: extraSales[index] ?? undefined,
          saleCategory: saleCategory[index] ?? undefined,
          saleComments: saleComments[index] ?? undefined,
          saleRefund: saleRefund[index] ?? undefined
        }))
        .filter(row => !this.state.removedRows.includes(row.id)); // Exclude removed salesRows

      const costRows = costPrice
        .map((_, index) => ({
          id: index,
          costPrice: costPrice[index] ?? undefined,
          costCategory: costCategory[index] ?? undefined,
          costComments: costComments[index] ?? undefined,
          costPerPerson: costPerPerson[index] ?? undefined
        }))
        .filter(row => !this.state.removedRowsCost.includes(row.id)); // Exclude removed salesRows

      this.setState(
        {
          costRows,
          salesRows
        },
        () => {
          console.log(
            'Rows initialized in componentDidMount:',
            this.state.salesRows
          );
        }
      );
    }
  };
  handleMainProductImageAlt1 = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        mainProductImageAlt1: imageUrl
      });
    });
  };
  handleMainProductImage = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        mainProductImage: imageUrl
      });
    });
  };
  handleMainProductImageAlt2 = info => {
    this.setState({
      loading: true
    });
    this.getBase64(info.file, imageUrl => {
      this.setState({
        loading: false,
        mainProductImageAlt2: imageUrl
      });
    });
  };

  handleImageUpload = ({ onSuccess, file }) => {
    onSuccess(true, file);
  };

  beforeUpload = file => {
    const isLt2M = file.size / 1024 / 1024 < 4;
    if (!isLt2M) {
      Notify('error', window.i18n.translate('ImageSmaller'));
    }
    return false;
  };
  getBase64 = (img, callback) => {
    Resizer.imageFileResizer(img, 1200, 1200, 'JPG', 100, 0, uri => {
      callback(uri);
    });
  };

  // Handle date change
  handleDateChange = date => {
    if (!date) {
      return;
    }

    const selectedDate = dayjs(date)
      .startOf('day')
      .toISOString(); // Normalize to the start of the day

    // Find matching room data by date
    const matchingRoom = this.props.stock.find(item => {
      if (!item.roomsDate) {
        console.warn(`roomsDate is undefined for Stock Item ID: ${item._id}`);
        return false; // Skip this item
      }
      const roomDate = dayjs(item.roomsDate)
        .startOf('day')
        .toISOString();

      return roomDate === selectedDate;
    });

    if (matchingRoom) {
      this.props.form.setFieldsValue({
        costRoomsAvail:
          matchingRoom.roomsAvail - matchingRoom.roomsBlocked || '',
        costStaffOnSite: matchingRoom.staffOnSite || '',
        costRooms: matchingRoom.roomsBooked || '',
        costBlocked: matchingRoom.roomsBlocked || '',
        costPAX: matchingRoom.roomsPAX || ''
        // costOccupancy:
        //   matchingRoom.roomsAvail && matchingRoom.roomsBooked
        //     ? Math.round(
        //       (matchingRoom.roomsBooked / matchingRoom.roomsAvail) * 100
        //     )
        //     : "",
      });
    } else {
    }
  };

  handleCategoryChange = (rowId, value) => {
    this.setState(prevState => ({
      dynamicLabels: {
        ...prevState.dynamicLabels,
        [rowId]: value || 'P/PAX' // ✅ Default value when category is cleared
      }
    }));
  };

  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const { form } = this.props;
    const { selectedYear } = this.state;
    const {
      previewVisible,
      costVisible,
      roomsVisible,
      previewVisibleVariant,
      previewImage,
      fileList,
      previewTitle
    } = this.state;

    const { editStock } = this.props;

    return (
      <span>
        <Form layout="vertical">
          {this.props.previewVisible ? (
            <StyledTabs
              animated={true}
              style={{ marginTop: '0em', marginLeft: '-24px' }}
              defaultActiveKey="1"
              tabPosition="left"
              type="card"
            >
              <>
                <TabPane tab="Details" key="Details">
                  <Row>
                    <Col span={12} style={{ textAlign: 'left' }}>
                      {/* <FormItem label="Refund">
                        {form.getFieldDecorator('isRefunded', {
                          rules: [
                            {
                              required: false
                            }
                          ],
                          initialValue: this.state.isRefunded ? true : false
                        })(
                          <Tooltip placement="left" title={form.getFieldValue(
                            'saleRefund'
                          ) == null
                            ? ''
                            : '"Clear Refund value to disable"'
                          }>
                            <Switch
                              // defaultChecked={true}
                              defaultChecked={
                                this.props.editStock &&
                                this.props.editStock.isRefunded
                              }
                              // disabled={true}
                              disabled={hasPrepStepsValue()}
                              onChange={checked =>
                                this.selectisRefunded(checked)
                              }
                              checkedChildren={<CheckOutlined />}
                              unCheckedChildren={<CloseOutlined />}
                            />
                          </Tooltip>
                        )}
                      </FormItem> */}
                    </Col>
                    {/* <Col span={12} style={{ textAlign: 'right' }}>
                    <FormItem>
                      {form.getFieldDecorator('isActive', {
                        rules: [{ required: false }],
                        initialValue: this.props.editStock
                          ? this.props.editStock.isActive === true
                          : true // Assuming true means 'Active' and false means 'Inactive'
                      })(
                        <Radio.Group buttonStyle="solid">
                          <Radio.Button value={true}>Complimentary / Refund</Radio.Button>
                        </Radio.Group>
                      )}
                    </FormItem>
                  </Col> */}
                    <Col span={5} style={{ display: 'none' }}>
                      <FormItem label={<span>Date</span>}>
                        {form.getFieldDecorator('timeDate', {
                          rules: [{}],
                          initialValue: this.props.editStock
                            ? this.props.editStock.timeDate
                            : this.state.curDT
                        })(
                          <StyledInput
                            variant="filled"
                            value={
                              this.props.editStock
                                ? this.props.editStock.timeDate
                                : this.state.curDT
                            }
                            // defaultValue={this.state.curDT}
                          />
                        )}
                      </FormItem>
                    </Col>
                    <Col span={1} />
                  </Row>
                  <Divider orientation="left" orientationmargin={0}>
                    Details
                  </Divider>
                  <Collapse
                    bordered={false}
                    defaultActiveKey={['1']}
                    expandIcon={({ isActive }) => (
                      <RightCircleFilled rotate={isActive ? 90 : 0} />
                    )}
                    items={[
                      {
                        key: '1',
                        label: 'Capture Your Information Here',
                        children: (
                          <>
                            {/* Date and Category (Only Once at the Top) */}
                            <Row
                              gutter={24}
                              style={{
                                padding: '2em',
                                paddingBottom: '0em',
                                paddingTop: '1em',
                                marginBottom: '2em'
                              }}
                            >
                              <Col span={4}>
                                <Form.Item label="Date">
                                  {form.getFieldDecorator('saleDate', {
                                    initialValue: this.props.editStock
                                      ? dayjs(this.props.editStock.saleDate)
                                      : undefined
                                  })(
                                    <DatePicker
                                      style={{ width: '100%' }}
                                      placeholder="Sale Date"
                                      size="large"
                                      // disabledDate={current => {
                                      //   const existingDates = this.props.stock
                                      //     .filter(item => item.saleDate)  // Filter out invalid dates
                                      //     .map(item => dayjs(item.saleDate).startOf('day').format("YYYY-MM-DD"))

                                      //   return existingDates.includes(dayjs(current).format("YYYY-MM-DD"));
                                      // }}
                                    />
                                  )}
                                </Form.Item>
                              </Col>
                              <Col span={4}>
                                <Form.Item label={`Booking Number `}>
                                  {form.getFieldDecorator(`bookingNr`, {
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.bookingNr
                                      : ''
                                  })(
                                    <Input
                                      size="large"
                                      style={{ width: '100%' }}
                                    />
                                  )}
                                </Form.Item>
                              </Col>
                              <Col span={4}>
                                <Form.Item label={`Room Number `}>
                                  {form.getFieldDecorator(`roomNr`, {
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.roomNr
                                      : ''
                                  })(
                                    <Input
                                      size="large"
                                      style={{ width: '100%' }}
                                    />
                                  )}
                                </Form.Item>
                              </Col>
                              <Col span={4}>
                                <Form.Item label={`Cash `}>
                                  {form.getFieldDecorator(`saleCash`, {
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.saleCash
                                      : ''
                                  })(
                                    <InputNumber
                                      size="large"
                                      style={{ width: '100%' }}
                                      step="0.01"
                                      min={0}
                                    />
                                  )}
                                </Form.Item>
                              </Col>

                              <Col span={4}>
                                <Form.Item label={`Card `}>
                                  {form.getFieldDecorator(`saleCard`, {
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.saleCard
                                      : ''
                                  })(
                                    <InputNumber
                                      size="large"
                                      style={{ width: '100%' }}
                                      step="0.01"
                                      min={0}
                                    />
                                  )}
                                </Form.Item>
                              </Col>

                              <Col span={4}>
                                <Form.Item label={`Bednights `}>
                                  {form.getFieldDecorator(`saleBednights`, {
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.saleBednights
                                      : ''
                                  })(
                                    <InputNumber
                                      size="large"
                                      style={{ width: '100%' }}
                                      min={0}
                                    />
                                  )}
                                </Form.Item>
                              </Col>
                              <Col span={9} style={{ display: 'none' }}>
                                {' '}
                                <FormItem label={<span>Assign To</span>}>
                                  {form.getFieldDecorator('access', {
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.access
                                      : this.props.siteSelected
                                  })(
                                    <Select
                                      // mode="multiple"
                                      showSearch
                                    >
                                      {/* <Option key="Admin" value="Admin">
                                      Admin
                                    </Option> */}
                                      {this.props.sites.map(site => (
                                        <Option key={site._id} value={site._id}>
                                          {site.name}
                                          {/* {site.name} ({site._id}) */}
                                        </Option>
                                      ))}
                                    </Select>
                                  )}
                                </FormItem>
                              </Col>
                            </Row>

                            {/* Repeating Rows for Cash, Card, Refund, Bednights */}
                            {this.state.salesRows.map(row => (
                              <Row
                                gutter={12}
                                key={row.id}
                                style={{
                                  padding: '2em',
                                  paddingBottom: '1.5em',
                                  paddingTop: '1em',
                                  borderTop: '1px dashed #d9d9d9'
                                }}
                              >
                                <Col span={4}>
                                  <Form.Item label="Category">
                                    {form.getFieldDecorator(
                                      `saleCategory[${row.id}]`,
                                      {
                                        initialValue: row.saleCategory
                                      }
                                    )(
                                      <Select
                                        size="large"
                                        allowClear
                                        style={{ width: '100%' }}
                                      >
                                        {[
                                          ...new Set(
                                            this.props.sites.flatMap(
                                              site => site.saleCategories || []
                                            )
                                          )
                                        ].map(category => (
                                          <Option
                                            key={category}
                                            value={category}
                                          >
                                            {category}
                                          </Option>
                                        ))}
                                      </Select>
                                    )}
                                  </Form.Item>
                                </Col>
                                <Col span={4}>
                                  <Form.Item label={`Extra Sales `}>
                                    {form.getFieldDecorator(
                                      `extraSales[${row.id}]`,
                                      {
                                        initialValue: row.extraSales
                                      }
                                    )(
                                      <InputNumber
                                        size="large"
                                        style={{ width: '100%' }}
                                        step="0.01"
                                        min={0}
                                      />
                                    )}
                                  </Form.Item>
                                </Col>
                                <Col span={4}>
                                  <Form.Item label={`Complimentary / Refund `}>
                                    {form.getFieldDecorator(
                                      `saleRefund[${row.id}]`,
                                      {
                                        initialValue: row.saleRefund
                                      }
                                    )(
                                      <InputNumber
                                        size="large"
                                        style={{ width: '100%' }}
                                        step="0.01"
                                        min={0}
                                      />
                                    )}
                                  </Form.Item>
                                </Col>
                                <Col span={9}>
                                  <Form.Item label={`Comments `}>
                                    {form.getFieldDecorator(
                                      `saleComments[${row.id}]`,
                                      {
                                        initialValue: row.saleComments
                                      }
                                    )(
                                      <Input
                                        size="large"
                                        style={{ width: '100%' }}
                                      />
                                    )}
                                  </Form.Item>
                                </Col>
                                <Col span={3} style={{ marginTop: '2.5em' }}>
                                  {this.state.salesRows.length > 1 &&
                                    row.id ===
                                      this.state.salesRows[
                                        this.state.salesRows.length - 1
                                      ].id && (
                                      <Button
                                        color="danger"
                                        variant="solid"
                                        onClick={() =>
                                          this.handleRemoveRow(row.id)
                                        }
                                      >
                                        Delete
                                      </Button>
                                    )}
                                </Col>
                              </Row>
                            ))}

                            <Row
                              style={{
                                paddingLeft: '2em',
                                paddingBottom: '2em',
                                paddingTop: '1em',
                                borderTop: '1px dashed #d9d9d9'
                              }}
                            >
                              <Col span={24}>
                                <Button
                                  icon={
                                    <PlusCircleFilled
                                      style={{
                                        fontSize: '110%',
                                        color: 'white'
                                      }}
                                    />
                                  }
                                  size="large"
                                  onClick={this.handleAddRow}
                                  style={{
                                    width: '10em',
                                    backgroundColor: 'black',
                                    color: 'white'
                                  }}
                                >
                                  Add Row
                                </Button>
                              </Col>
                            </Row>
                          </>
                        )
                      }
                    ]}
                  />
                  {/* <Divider orientation="left" orientationmargin={0}>
                    Proof of Sale
                  </Divider>
                  <Collapse
                    bordered={false}
                    defaultActiveKey={['3']}
                    expandIcon={({ isActive }) => (
                      <RightCircleFilled rotate={isActive ? 90 : 0} />
                    )}
                    items={[
                      {
                        key: '3',
                        label: 'Upload Proof of Sale',
                        children: (
                          <Row
                            gutter={24}
                            style={{ padding: '2em', marginTop: '0em', paddingTop: '0.5em', paddingBottom: '2em', }}
                          >
                            <Col span={8} style={{ padding: '0.5em' }}>
                              <h1
                                style={{
                                  marginBottom: '1em',
                                  fontSize: '15px',
                                  fontWeight: 400
                                  // fontFamily: "Nunito",
                                }}
                              >
                                Proof of Sale Image
                              </h1>
                              <Upload
                                name="mainProductImage"
                                className="avatar-uploader"
                                listType="picture-card"
                                showUploadList={false}
                                beforeUpload={this.beforeUpload}
                                customRequest={this.handleImageUpload}
                                onChange={this.handleMainProductImage}
                                loading={this.state.loading}
                                accept="image/*"
                                disabled={!!this.state.mainProductImage} // Disable if the image exists
                              >
                                {this.state.mainProductImage ? (
                                  <img
                                    style={{
                                      width: '100%',
                                      height: '20em',
                                      objectFit: 'contain'
                                    }}
                                    alt="example"
                                    src={
                                      this.state.mainProductImage.search('data') > -1
                                        ? this.state.mainProductImage
                                        : process.env.REACT_APP_GLOBAL_SERVER +
                                        'sproutmanagement/api/images/' +
                                        this.state.mainProductImage
                                    }
                                  />
                                ) : (
                                  <div style={{ marginTop: 8 }}>
                                    Upload
                                  </div>
                                )}
                              </Upload>
                              <Button
                                size="large"
                                onClick={() => {
                                  this.props.handleDeleteImage(); // Delete image handler
                                  this.setState({ mainProductImage: null }); // Clear image from state
                                }}
                                style={{
                                  background: !this.state.mainProductImage ? "lightgrey" : 'red',
                                  color: 'white',
                                  border: "none",
                                  marginRight: '1em',
                                }}
                                disabled={!this.state.mainProductImage} // Disable delete if no image exists
                              >
                                Delete
                              </Button>
                            </Col>
                          </Row>
                        )
                      }
                    ]}
                  /> */}
                </TabPane>
                {/* {!this.state.isRefunded ||
                this.state.isRefunded === false ? null : (
                <TabPane tab="Complimentary / Refund" key="Refund">
                  <Divider orientation="left" orientationmargin={0}>
                    Create Sale Options
                  </Divider>
                  <Collapse
                    bordered={false}
                    defaultActiveKey={['1']}
                    expandIcon={({ isActive }) => (
                      <RightCircleFilled rotate={isActive ? 90 : 0} />
                    )}
                    items={[
                      {
                        key: '1',
                        label: 'Create a variety of product options',
                        children: (
                          <>
                            <Row
                              gutter={24}
                              style={{
                                paddingBottom: '1em',
                                display:
                                  !this.state.isRefunded ||
                                    this.state.isRefunded === false
                                    ? 'none'
                                    : ''
                              }}
                            >
                              <Col span={24} style={{ padding: 0 }}>


                              </Col>
                            </Row>{' '}
                          </>
                        )
                      }
                    ]}
                  />
                </TabPane>
              )} */}
              </>
            </StyledTabs>
          ) : this.props.costVisible ? (
            <StyledTabs
              animated={true}
              style={{ marginTop: '0em', marginLeft: '-24px' }}
              defaultActiveKey="1"
              tabPosition="left"
              type="card"
            >
              <>
                <TabPane tab="Sales Details" key="2">
                  <Row>
                    <Col span={5} style={{ display: 'none' }}>
                      <FormItem label={<span>Date</span>}>
                        {form.getFieldDecorator('timeDate', {
                          rules: [{}],
                          initialValue: this.props.editStock
                            ? this.props.editStock.timeDate
                            : this.state.curDT
                        })(
                          <StyledInput
                            variant="filled"
                            value={
                              this.props.editStock
                                ? this.props.editStock.timeDate
                                : this.state.curDT
                            }
                            // defaultValue={this.state.curDT}
                          />
                        )}
                      </FormItem>
                    </Col>
                    <Col span={1} />
                  </Row>
                  <Divider orientation="left" orientationmargin={0}>
                    Details
                  </Divider>
                  <Collapse
                    bordered={false}
                    defaultActiveKey={['1']}
                    expandIcon={({ isActive }) => (
                      <RightCircleFilled rotate={isActive ? 90 : 0} />
                    )}
                    items={[
                      {
                        key: '1',
                        label: 'Capture Your Information Here',
                        children: (
                          <>
                            <Row
                              gutter={24}
                              style={{
                                padding: '2em',
                                paddingBottom: '0em',
                                paddingTop: '1em'
                              }}
                            >
                              <Col span={5}>
                                <FormItem label="Date">
                                  {form.getFieldDecorator('costDate', {
                                    rules: [
                                      {
                                        required: false,
                                        message: 'Category required'
                                      }
                                    ],
                                    initialValue: this.props.editStock
                                      ? dayjs(this.props.editStock.costDate)
                                      : undefined
                                  })(
                                    <DatePicker
                                      style={{ width: '100%' }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'costDate'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                      size="large"
                                      placeholder="Cost Date"
                                      onChange={this.handleDateChange} // Trigger date change logic
                                      disabledDate={current => {
                                        const existingDates = this.props.stock
                                          .filter(item => item.costDate) // Filter out invalid dates
                                          .map(item =>
                                            dayjs(item.costDate)
                                              .startOf('day')
                                              .format('YYYY-MM-DD')
                                          );

                                        return existingDates.includes(
                                          dayjs(current).format('YYYY-MM-DD')
                                        );
                                      }}
                                    />
                                  )}
                                </FormItem>
                              </Col>
                              {/* <Col span={5} style={{ marginBottom: '1em' }}>
                                <FormItem label="Category">
                                  {form.getFieldDecorator(
                                    'costCategory',
                                    {
                                      rules: [
                                        {
                                          required: false,
                                          message: 'Sale Title required'
                                        }
                                      ],
                                      initialValue: this.props.editStock
                                        ? this.props.editStock.costCategory
                                        : []
                                    }
                                  )(
                                    <Select
                                      size="large"
                                      allowClear
                                      style={{ width: '100%' }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'costCategory'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                    >
                                      {[...new Set(this.props.sites.flatMap(site => site.costCategories || []))].map(category => (
                                        <Option key={category} value={category}>
                                          {category}
                                        </Option>
                                      ))}
                                    </Select>
                                  )}
                                </FormItem>
                              </Col> */}
                              <Col span={4}>
                                <Form.Item label={`Daily Budget `}>
                                  {form.getFieldDecorator(`costBudget`, {
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.costBudget
                                      : ''
                                  })(
                                    <InputNumber
                                      variant={
                                        this.props.form.getFieldValue(
                                          'costBudget'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                      size="large"
                                      style={{ width: '100%' }}
                                      step="0.01"
                                      min={0}
                                    />
                                  )}
                                </Form.Item>
                              </Col>
                              <Col span={4}>
                                <FormItem label="Staff On Site">
                                  {form.getFieldDecorator('costStaffOnSite', {
                                    rules: [
                                      {
                                        required: false,
                                        message: 'Staff On Site required'
                                      }
                                    ],
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.costStaffOnSite
                                      : ''
                                  })(
                                    <StyledInputNumber
                                      disabled
                                      style={{ width: '100%' }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'costStaffOnSite'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                      size="large"
                                      placeholder="Staff On Site"
                                    />
                                  )}
                                </FormItem>
                              </Col>
                            </Row>
                            <Row
                              gutter={24}
                              style={{
                                padding: '2em',
                                paddingBottom: '0em',
                                paddingTop: '1.5em',
                                marginBottom: '1.5em'
                              }}
                            >
                              <Col span={5}>
                                <FormItem label="Rooms Available">
                                  {form.getFieldDecorator('costRoomsAvail', {
                                    rules: [
                                      {
                                        required: false,
                                        message: 'Category required'
                                      }
                                    ],
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.costRoomsAvail
                                      : ''
                                  })(
                                    <StyledInputNumber
                                      disabled
                                      style={{ width: '100%' }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'costRoomsAvail'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                      size="large"
                                      placeholder="Rooms Available"
                                    />
                                  )}
                                </FormItem>
                              </Col>
                              <Col span={5}>
                                <FormItem label="Rooms Booked">
                                  {form.getFieldDecorator('costRooms', {
                                    rules: [
                                      {
                                        required: false,
                                        message: 'Category required'
                                      }
                                    ],
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.costRooms
                                      : ''
                                  })(
                                    <StyledInputNumber
                                      disabled
                                      style={{ width: '100%' }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'costRooms'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                      size="large"
                                      placeholder="Rooms Booked"
                                    />
                                  )}
                                </FormItem>
                              </Col>

                              <Col span={5}>
                                <FormItem label="Occupancy %">
                                  {form.getFieldDecorator('costOccupancy', {
                                    rules: [
                                      {
                                        required: false,
                                        message: 'Category required'
                                      }
                                    ],
                                    initialValue:
                                      this.props.form.getFieldValue(
                                        'costRooms'
                                      ) &&
                                      this.props.form.getFieldValue(
                                        'costRoomsAvail'
                                      )
                                        ? Math.round(
                                            (this.props.form.getFieldValue(
                                              'costRooms'
                                            ) /
                                              this.props.form.getFieldValue(
                                                'costRoomsAvail'
                                              )) *
                                              100
                                          ) // Ensure the value is a number
                                        : undefined,
                                    getValueFromEvent: value =>
                                      typeof value === 'string'
                                        ? Number(value)
                                        : value // Convert string to number
                                  })(
                                    <StyledInputNumber
                                      disabled
                                      style={{ width: '100%' }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'costOccupancy'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                      size="large"
                                      placeholder="Occupancy %"
                                    />
                                  )}
                                </FormItem>
                              </Col>
                              <Col span={5}>
                                <FormItem label="PAX">
                                  {form.getFieldDecorator('costPAX', {
                                    rules: [
                                      {
                                        required: false,
                                        message: 'Category required'
                                      }
                                    ],
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.costPAX
                                      : ''
                                  })(
                                    <StyledInputNumber
                                      disabled
                                      style={{ width: '100%' }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'costPAX'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                      size="large"
                                      placeholder="PAX"
                                    />
                                  )}
                                </FormItem>
                              </Col>
                              <Col span={9} style={{ display: 'none' }}>
                                {' '}
                                <FormItem label={<span>Assign To</span>}>
                                  {form.getFieldDecorator('access', {
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.access
                                      : this.props.siteSelected
                                  })(
                                    <Select
                                      // mode="multiple"
                                      showSearch
                                    >
                                      {/* <Option key="Admin" value="Admin">
                                      Admin
                                    </Option> */}
                                      {this.props.sites.map(site => (
                                        <Option key={site._id} value={site._id}>
                                          {site.name}
                                          {/* {site.name} ({site._id}) */}
                                        </Option>
                                      ))}
                                    </Select>
                                  )}
                                </FormItem>
                              </Col>
                            </Row>
                            {this.state.costRows.map(row => {
                              const categoryValue =
                                this.props.form.getFieldValue(
                                  `costCategory[${row.id}]`
                                ) || row.costCategory;
                              const labelText =
                                categoryValue === 'Staff Food'
                                  ? 'P/Staff'
                                  : 'P/PAX';

                              // ✅ Determine which field to use: `staffOnSite` for "Staff Food", `costPAX` otherwise
                              const peopleCountField =
                                categoryValue === 'Staff Food'
                                  ? 'costStaffOnSite'
                                  : 'costPAX';

                              return (
                                <Row
                                  gutter={12}
                                  key={row.id}
                                  style={{
                                    padding: '2em',
                                    paddingBottom: '1.5em',
                                    paddingTop: '1em',
                                    borderTop: '1px dashed #d9d9d9'
                                  }}
                                >
                                  <Col span={4}>
                                    <Form.Item label="Category">
                                      {form.getFieldDecorator(
                                        `costCategory[${row.id}]`,
                                        {
                                          initialValue: row.costCategory
                                        }
                                      )(
                                        <Select
                                          size="large"
                                          allowClear
                                          style={{ width: '100%' }}
                                          onChange={value =>
                                            this.handleCategoryChange(
                                              row.id,
                                              value
                                            )
                                          }
                                        >
                                          {[
                                            ...new Set(
                                              this.props.sites.flatMap(
                                                site =>
                                                  site.costCategories || []
                                              )
                                            )
                                          ].map(category => (
                                            <Option
                                              key={category}
                                              value={category}
                                            >
                                              {category}
                                            </Option>
                                          ))}
                                        </Select>
                                      )}
                                    </Form.Item>
                                  </Col>
                                  <Col span={3}>
                                    <Form.Item label={`Cost `}>
                                      {form.getFieldDecorator(
                                        `costPrice[${row.id}]`,
                                        {
                                          initialValue: row.costPrice
                                        }
                                      )(
                                        <InputNumber
                                          size="large"
                                          style={{ width: '100%' }}
                                          step="0.01"
                                          min={0}
                                        />
                                      )}
                                    </Form.Item>
                                  </Col>
                                  <Col span={3}>
                                    <Form.Item label={labelText}>
                                      {form.getFieldDecorator(
                                        `costPerPerson[${row.id}]`,
                                        {
                                          initialValue:
                                            this.props.form.getFieldValue(
                                              `costPrice[${row.id}]`
                                            ) &&
                                            this.props.form.getFieldValue(
                                              peopleCountField
                                            ) // ✅ Uses staffOnSite for Staff Food, costPAX otherwise
                                              ? Math.round(
                                                  (this.props.form.getFieldValue(
                                                    `costPrice[${row.id}]`
                                                  ) /
                                                    this.props.form.getFieldValue(
                                                      peopleCountField
                                                    )) *
                                                    100
                                                ) / 100
                                              : undefined
                                        }
                                      )(
                                        <InputNumber
                                          size="large"
                                          style={{ width: '100%' }}
                                          step="0.01"
                                          min={0}
                                        />
                                      )}
                                    </Form.Item>
                                  </Col>
                                  <Col span={11}>
                                    <Form.Item label={`Comments `}>
                                      {form.getFieldDecorator(
                                        `costComments[${row.id}]`,
                                        {
                                          initialValue: row.costComments
                                        }
                                      )(
                                        <Input
                                          size="large"
                                          style={{ width: '100%' }}
                                        />
                                      )}
                                    </Form.Item>
                                  </Col>
                                  <Col span={3} style={{ marginTop: '2.5em' }}>
                                    {this.state.costRows.length > 1 &&
                                      row.id ===
                                        this.state.costRows[
                                          this.state.costRows.length - 1
                                        ].id && (
                                        <Button
                                          color="danger"
                                          variant="solid"
                                          onClick={() =>
                                            this.handleRemoveRowCost(row.id)
                                          }
                                        >
                                          Delete
                                        </Button>
                                      )}
                                  </Col>
                                </Row>
                              );
                            })}

                            <Row
                              style={{
                                paddingLeft: '2em',
                                paddingBottom: '2em',
                                paddingTop: '1em',
                                borderTop: '1px dashed #d9d9d9'
                              }}
                            >
                              <Col span={24}>
                                <Button
                                  icon={
                                    <PlusCircleFilled
                                      style={{
                                        fontSize: '110%',
                                        color: 'white'
                                      }}
                                    />
                                  }
                                  size="large"
                                  onClick={this.handleAddRowCost}
                                  style={{
                                    width: '10em',
                                    backgroundColor: 'black',
                                    color: 'white'
                                  }}
                                >
                                  Add Row
                                </Button>
                              </Col>
                            </Row>

                            {/* <Row
                              gutter={24}
                              style={{ padding: '2em', paddingBottom: '2em', paddingTop: '1em', borderTop: "1px dashed #d9d9d9", }}
                            >
                              <Col span={24} style={{ marginTop: '1em', paddingBottom: "2em" }}>
                                <FormItem
                                  // style={{ marginBottom: '1em' }}
                                  label="Remarks/ Comments"
                                >
                                  {form.getFieldDecorator(
                                    'costNote',
                                    {
                                      rules: [
                                        {
                                          required: false,
                                          message: 'Category required'
                                        }
                                      ],
                                      initialValue: this.props.editStock
                                        ? this.props.editStock.costNote
                                        : ""
                                    }
                                  )(
                                    <TextArea
                                      style={{ width: "100%" }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'costNote'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                      size="large"
                                      placeholder="Enter Comments"
                                    />
                                  )}
                                </FormItem>
                              </Col>
                            </Row> */}
                          </>
                        )
                      }
                    ]}
                  />
                </TabPane>
                {/* {!this.state.isRefunded ||
                this.state.isRefunded === false ? null : (
                <TabPane tab="Complimentary / Refund" key="Refund">
                  <Divider orientation="left" orientationmargin={0}>
                    Create Sale Options
                  </Divider>
                  <Collapse
                    bordered={false}
                    defaultActiveKey={['1']}
                    expandIcon={({ isActive }) => (
                      <RightCircleFilled rotate={isActive ? 90 : 0} />
                    )}
                    items={[
                      {
                        key: '1',
                        label: 'Create a variety of product options',
                        children: (
                          <>
                            <Row
                              gutter={24}
                              style={{
                                paddingBottom: '1em',
                                display:
                                  !this.state.isRefunded ||
                                    this.state.isRefunded === false
                                    ? 'none'
                                    : ''
                              }}
                            >
                              <Col span={24} style={{ padding: 0 }}>


                              </Col>
                            </Row>{' '}
                          </>
                        )
                      }
                    ]}
                  />
                </TabPane>
              )} */}
              </>
            </StyledTabs>
          ) : this.props.roomsVisible ? (
            <StyledTabs
              animated={true}
              style={{ marginTop: '0em', marginLeft: '-24px' }}
              defaultActiveKey="1"
              tabPosition="left"
              type="card"
            >
              <>
                <TabPane tab="Cost Details" key="3">
                  <Row>
                    <Col span={5} style={{ display: 'none' }}>
                      <FormItem label={<span>Date</span>}>
                        {form.getFieldDecorator('timeDate', {
                          rules: [{}],
                          initialValue: this.props.editStock
                            ? this.props.editStock.timeDate
                            : this.state.curDT
                        })(
                          <StyledInput
                            variant="filled"
                            value={
                              this.props.editStock
                                ? this.props.editStock.timeDate
                                : this.state.curDT
                            }
                            // defaultValue={this.state.curDT}
                          />
                        )}
                      </FormItem>
                    </Col>
                    <Col span={1} />
                  </Row>
                  <Divider orientation="left" orientationmargin={0}>
                    Details
                  </Divider>
                  <Collapse
                    bordered={false}
                    defaultActiveKey={['1']}
                    expandIcon={({ isActive }) => (
                      <RightCircleFilled rotate={isActive ? 90 : 0} />
                    )}
                    items={[
                      {
                        key: '1',
                        label: 'Capture Your Information Here',
                        children: (
                          <>
                            <Row
                              gutter={24}
                              style={{
                                padding: '2em',
                                paddingBottom: '0em',
                                paddingTop: '1em'
                              }}
                            >
                              <Col span={5}>
                                <FormItem
                                  // style={{ marginBottom: '1em' }}
                                  label="Date"
                                >
                                  {form.getFieldDecorator('roomsDate', {
                                    rules: [
                                      {
                                        required: false,
                                        message: 'Category required'
                                      }
                                    ],
                                    initialValue: this.props.editStock
                                      ? dayjs(
                                          this.props.editStock.roomsDate
                                        ).utc()
                                      : undefined
                                  })(
                                    <DatePicker
                                      style={{ width: '100%' }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'roomsDate'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                      size="large"
                                      placeholder="Select Date"
                                      disabledDate={current => {
                                        const existingDates = this.props.stock
                                          .filter(item => item.roomsDate) // Filter out invalid dates
                                          .map(item =>
                                            dayjs(item.roomsDate)
                                              .startOf('day')
                                              .format('YYYY-MM-DD')
                                          );

                                        return existingDates.includes(
                                          dayjs(current).format('YYYY-MM-DD')
                                        );
                                      }}
                                    />
                                  )}
                                </FormItem>
                              </Col>
                              <Col span={5}>
                                <FormItem label="Staff On Site">
                                  {form.getFieldDecorator('staffOnSite', {
                                    rules: [
                                      {
                                        required: false,
                                        message: 'Staff On Site required'
                                      }
                                    ],
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.staffOnSite
                                      : ''
                                  })(
                                    <StyledInputNumber
                                      style={{ width: '100%' }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'staffOnSite'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                      size="large"
                                      placeholder="Staff On Site"
                                    />
                                  )}
                                </FormItem>
                              </Col>
                              <Col
                                span={5}
                                style={{ marginBottom: '1em', display: 'none' }}
                              >
                                <FormItem label="Category">
                                  {form.getFieldDecorator('roomsCategory', {
                                    rules: [
                                      {
                                        required: false,
                                        message: 'Sale Title required'
                                      }
                                    ],
                                    initialValue: 'Rooms'
                                  })(
                                    <StyledInput
                                      size="large"
                                      allowClear
                                      style={{ width: '100%' }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'roomsCategory'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                    />
                                  )}
                                </FormItem>
                              </Col>
                              {/* <Col span={5} style={{ marginBottom: '1em' }}>
                                <FormItem label="Category">
                                  {form.getFieldDecorator(
                                    'costCategory',
                                    {
                                      rules: [
                                        {
                                          required: false,
                                          message: 'Sale Title required'
                                        }
                                      ],
                                      initialValue: this.props.editStock
                                        ? this.props.editStock.costCategory
                                        : []
                                    }
                                  )(
                                    <Select
                                      size="large"
                                      allowClear
                                      style={{ width: '100%' }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'costCategory'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                    >
                                      <Option key="Room" value="Room">
                                        Room
                                      </Option>
                                      <Option key="Bar" value="Bar">
                                        Bar
                                      </Option>
                                      <Option key="Housekeeping" value="Housekeeping">
                                        Housekeeping
                                      </Option>
                                      <Option key="Gas" value="Gas">
                                        Gas
                                      </Option>
                                      <Option key="Kerosene" value="Kerosene">
                                        Kerosene
                                      </Option>
                                      <Option key="Drivers" value="Drivers">
                                        Drivers
                                      </Option>
                                    </Select>
                                  )}
                                </FormItem>
                              </Col> */}
                            </Row>
                            <Row
                              gutter={24}
                              style={{
                                padding: '2em',
                                paddingBottom: '2em',
                                paddingTop: '1.5em',
                                borderTop: '1px dashed #d9d9d9',
                                marginTop: '2em'
                              }}
                            >
                              <Col span={4}>
                                <FormItem
                                  // style={{ marginBottom: '1em' }}
                                  label="Rooms Available"
                                >
                                  {form.getFieldDecorator('roomsAvail', {
                                    rules: [
                                      {
                                        required: false,
                                        message: 'Category required'
                                      }
                                    ],
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.roomsAvail
                                      : ''
                                  })(
                                    <StyledInputNumber
                                      style={{ width: '100%' }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'roomsAvail'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                      size="large"
                                      placeholder="Rooms Available"
                                    />
                                  )}
                                </FormItem>
                              </Col>
                              <Col span={4}>
                                <FormItem
                                  // style={{ marginBottom: '1em' }}
                                  label="Rooms Booked"
                                >
                                  {form.getFieldDecorator('roomsBooked', {
                                    rules: [
                                      {
                                        required: false,
                                        message: 'Category required'
                                      }
                                    ],
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.roomsBooked
                                      : ''
                                  })(
                                    <StyledInputNumber
                                      style={{ width: '100%' }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'roomsBooked'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                      size="large"
                                      placeholder="Rooms Booked"
                                    />
                                  )}
                                </FormItem>
                              </Col>
                              <Col span={4}>
                                <FormItem
                                  // style={{ marginBottom: '1em' }}
                                  label="Blocked Rooms"
                                >
                                  {form.getFieldDecorator('roomsBlocked', {
                                    rules: [
                                      {
                                        required: false,
                                        message: 'Category required'
                                      }
                                    ],
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.roomsBlocked
                                      : ''
                                  })(
                                    <StyledInputNumber
                                      style={{ width: '100%' }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'roomsBlocked'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                      size="large"
                                      placeholder="Blocked Rooms"
                                    />
                                  )}
                                </FormItem>
                              </Col>
                              <Col span={4}>
                                <FormItem label="Guide Meals">
                                  {form.getFieldDecorator('guideMeals', {
                                    rules: [
                                      {
                                        required: false,
                                        message: 'Guide meals required'
                                      }
                                    ],
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.guideMeals
                                      : ''
                                  })(
                                    <StyledInputNumber
                                      min={0}
                                      precision={0}
                                      style={{ width: '100%' }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'guideMeals'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                      size="large"
                                      placeholder="Guide Meals"
                                    />
                                  )}
                                </FormItem>
                              </Col>
                            </Row>
                            <Row
                              gutter={24}
                              style={{
                                padding: '2em',
                                paddingBottom: '2em',
                                paddingTop: '1.5em',
                                borderTop: '1px dashed #d9d9d9'
                              }}
                            >
                              <Col span={4}>
                                <FormItem
                                  // style={{ marginBottom: '1em' }}
                                  label="PAX"
                                >
                                  {form.getFieldDecorator('roomsPAX', {
                                    rules: [
                                      {
                                        required: false,
                                        message: 'Category required'
                                      }
                                    ],
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.roomsPAX
                                      : ''
                                  })(
                                    <StyledInputNumber
                                      style={{ width: '100%' }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'roomPAX'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                      size="large"
                                      placeholder="Enter PAX"
                                    />
                                  )}
                                </FormItem>
                              </Col>
                              <Col span={4}>
                                <FormItem label="Occupancy %">
                                  {form.getFieldDecorator('roomOccupancy', {
                                    rules: [
                                      {
                                        required: false,
                                        message: 'Category required'
                                      }
                                    ],
                                    initialValue:
                                      this.props.form.getFieldValue(
                                        'roomsBooked'
                                      ) &&
                                      this.props.form.getFieldValue(
                                        'roomsAvail'
                                      )
                                        ? Math.round(
                                            (this.props.form.getFieldValue(
                                              'roomsBooked'
                                            ) /
                                              (this.props.form.getFieldValue(
                                                'roomsAvail'
                                              ) -
                                                (this.props.form.getFieldValue(
                                                  'roomsBlocked'
                                                ) || 0))) *
                                              100
                                          )
                                        : undefined,
                                    getValueFromEvent: value =>
                                      typeof value === 'string'
                                        ? Number(value)
                                        : value // Convert string to number
                                  })(
                                    <StyledInputNumber
                                      disabled
                                      style={{ width: '100%' }}
                                      variant={
                                        this.props.form.getFieldValue(
                                          'roomOccupancy'
                                        ) == null
                                          ? 'outlined'
                                          : 'filled'
                                      }
                                      size="large"
                                      placeholder="Occupancy %"
                                    />
                                  )}
                                </FormItem>
                              </Col>
                              <Col span={4} />
                              <Col span={9} style={{ display: 'none' }}>
                                {' '}
                                <FormItem label={<span>Assign To</span>}>
                                  {form.getFieldDecorator('access', {
                                    initialValue: this.props.editStock
                                      ? this.props.editStock.access
                                      : this.props.siteSelected
                                  })(
                                    <Select
                                      // mode="multiple"
                                      showSearch
                                    >
                                      {/* <Option key="Admin" value="Admin">
                                      Admin
                                    </Option> */}
                                      {this.props.sites.map(site => (
                                        <Option key={site._id} value={site._id}>
                                          {site.name}
                                          {/* {site.name} ({site._id}) */}
                                        </Option>
                                      ))}
                                    </Select>
                                  )}
                                </FormItem>
                              </Col>
                            </Row>
                          </>
                        )
                      }
                    ]}
                  />
                </TabPane>
                {/* {!this.state.isRefunded ||
                this.state.isRefunded === false ? null : (
                <TabPane tab="Complimentary / Refund" key="Refund">
                  <Divider orientation="left" orientationmargin={0}>
                    Create Sale Options
                  </Divider>
                  <Collapse
                    bordered={false}
                    defaultActiveKey={['1']}
                    expandIcon={({ isActive }) => (
                      <RightCircleFilled rotate={isActive ? 90 : 0} />
                    )}
                    items={[
                      {
                        key: '1',
                        label: 'Create a variety of product options',
                        children: (
                          <>
                            <Row
                              gutter={24}
                              style={{
                                paddingBottom: '1em',
                                display:
                                  !this.state.isRefunded ||
                                    this.state.isRefunded === false
                                    ? 'none'
                                    : ''
                              }}
                            >
                              <Col span={24} style={{ padding: 0 }}>


                              </Col>
                            </Row>{' '}
                          </>
                        )
                      }
                    ]}
                  />
                </TabPane>
              )} */}
              </>
            </StyledTabs>
          ) : null}
          <Modal
            visible={previewVisible}
            title={previewTitle}
            footer={null}
            onCancel={this.handleCancel}
          >
            <img alt="example" style={{ width: '100%' }} src={previewImage} />
          </Modal>{' '}
        </Form>
      </span>
    );
  }
}
const StockForm = Form.create()(AddStockForm);

class Stock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCategory: null, // Store the selected category
      selectedCategoryCost: null, // Store the selected category
      selectedCategoryRooms: null, // Store the selected category
      open: false,
      loading: false,
      closed: false,
      rejectReason: '',
      editStock: undefined,
      size: 'large',
      flag: false,
      currentTab: 'All',
      openSteps: false,
      searchText: '',
      expandedRowKeys: [],
      duplicateModal: false,
      dataSource: this.props.stock,
      siteSelected: this.props.sites[0] ? this.props.sites[0]._id : null,
      stockData: [],
      totalStock: 0,
      currentPage: 1,
      selectedYear: dayjs().format('YYYY'),
      activeTabKey: 'Variable Rooms',
      pageSize: 1000, // or any default page size you prefer
      filteredRooms: [],
      steps: [
        {
          title: 'Add a Sale',
          description: 'Click Here to add a new awesome product!',
          placement: 'right',
          target: () => this.ref.current
        }
      ]
    };
    this.ref = React.createRef();
  }
  handleSearchProduct = value => {
    this.setState({ searchText: value });
  };

  componentDidMount = value => {
    this.setState({ loading: true, selectedYear: dayjs().format('YYYY') });

    Promise.all([
      this.fetchAllStock(),
      this.fetchAllSites(),
      this.fetchAllUsers()
    ])
      .then(() => {
        this.setState({
          loading: false
          // siteSelected: this.props.sites[0]._id
        });
      })
      .catch(error => {
        console.error('Error during componentDidMount:', error);
        this.setState({ loading: false });
        Notify('error', 'Error', error.message || 'An error occurred');
      });

    window.addEventListener('resize', this.resizeEvent);
    if (window.cordova) {
      document.addEventListener('backbutton', this.handleBack);
    }
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeEvent);
    if (window.cordova) {
      document.removeEventListener('backbutton', this.handleBack);
    }
  }

  fetchAllStock = async (page = 1, pageSize = 1000) => {
    try {
      this.setState({ loading: true });
      const response = await this.props.findAllStock(
        this.state.siteSelected,
        this.state.currentPage,
        this.state.pageSize
      );
      const { stock, total } = response.data; // Assuming your API returns stock and total items count

      this.setState({
        stockData: stock,
        totalStock: total,
        stock: stock,
        totalItems: total,
        currentPage: page,
        pageSize,
        loading: false
      });
    } catch (error) {
      this.setState({ loading: false });
      Notify('error', error.message);
    }
  };
  fetchAllSites = () => {
    return this.props.findAllSites().catch(error => {
      throw new Error(`Error fetching sites: ${error}`);
    });
  };

  fetchAllUsers = () => {
    return this.props.findAllUsers().catch(error => {
      throw new Error(`Error fetching users: ${error}`);
    });
  };

  resizeEvent = () => {
    this.setState({ loading: false });
  };
  stopProp = e => {
    e.stopPropagation();
  };

  stockForm;
  onAddStock = e => {
    this.setState({ previewVisible: true, editStock: undefined });
  };

  onAddStockCost = e => {
    this.setState({ costVisible: true, editStock: undefined });
  };

  onAddStockRooms = e => {
    this.setState({ roomsVisible: true, editStock: undefined });
  };

  handleDeleteImage = () => {
    const imageField = 'mainProductImage';
    const imageId = this.state.editStock?.[imageField]; // Get the image name

    if (!imageId) {
      Notify('error', 'No image available to delete');
      return;
    }

    this.props
      .deleteStockImage(imageId, imageField)
      .then(() => {
        this.setState({ [imageField]: null }); // Clear the image from the state
        Notify('success', 'Image deleted successfully');
      })
      .catch(error => {
        Notify('error', `Error deleting image: ${error.message}`);
      });
  };
  handleDeleteImage2 = () => {
    const imageField = 'mainProductImageAlt1';
    const imageId = this.state.editStock?.[imageField]; // Get the image name

    if (!imageId) {
      Notify('error', 'No image available to delete');
      return;
    }

    this.props
      .deleteStockImage(imageId, imageField)
      .then(() => {
        this.setState({ [imageField]: null }); // Clear the image from the state
        Notify('success', 'Image deleted successfully');
      })
      .catch(error => {
        Notify('error', `Error deleting image: ${error.message}`);
      });
  };
  handleAddStock = async e => {
    e.preventDefault();

    this.stockForm.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        this.setState({ loading: true });

        // Map varProductImage1 to varProductImage125
        // const imageFields = Array.from(
        //   { length: 125 },
        //   (_, i) => `varProductImage${i + 1}` // Correct template literal usage
        // );
        // imageFields.forEach((field) => {
        //   values[field] = this.stockForm.state[field] || null; // Fallback for undefined
        // });

        // Map main product images
        // values.mainProductImageAlt1 = this.stockForm.state.mainProductImageAlt1 || null;
        // values.mainProductImage = this.stockForm.state.mainProductImage || null;
        // values.mainProductImageAlt2 = this.stockForm.state.mainProductImageAlt2 || null;

        // Add _id if editing stock
        if (this.state.editStock) {
          values._id = this.state.editStock._id;
        }

        try {
          // Process values araaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaays!!!!!!!!!!!!!!!!!!!
          // if (Array.isArray(values.access)) {
          //   for (let siteId of values.access) {
          //     const newValues = { ...values, access: [siteId] };

          //     await this.props.addStock(newValues);
          //   }
          // } else {
          //   await this.props.addStock(values);
          // }
          await this.props.addStock(values);
          // Fetch updated stock data
          const response = await this.props.findAllStock(
            this.state.siteSelected,
            this.state.currentPage,
            this.state.pageSize
          );

          const { stock, total } = response.data;

          // Update state with new stock data
          this.setState({
            stockData: stock,
            totalStock: total,
            totalItems: total,
            loading: false,
            addStockVisible: false,
            editStock: undefined,
            previewVisible: false,
            costVisible: false,
            roomsVisible: false,
            previewVisibleVariant: false,
            currentTab: 'All'
          });

          Notify('success', 'Successfully added');
        } catch (error) {
          console.error('Error while adding stock:', error);
          Notify('error', error.message || 'An error occurred.');
        } finally {
          this.setState({ loading: false });
        }
      } else {
        console.error('Validation failed:', err);
      }
    });
  };

  handleEditStock = e => {
    this.setState({ previewVisible: true, editStock: e });
  };
  handleEditStockCost = e => {
    this.setState({ costVisible: true, editStock: e });
  };
  handleEditStockRooms = e => {
    this.setState({ roomsVisible: true, editStock: e });
  };
  handleDeleteStock = async e => {
    this.setState({ loading: true, deleteVisible: false });

    try {
      // Destructure necessary state values
      const { deleteStock, siteSelected, currentPage, pageSize } = this.state;

      // Delete the selected stock item
      await this.props.deleteStock(deleteStock._id);

      // Fetch the updated list of ingredients after deletion
      const response = await this.props.findAllStock(
        siteSelected,
        currentPage,
        pageSize
      );

      // Check if response is valid and contains data
      const stock = response?.data?.stock || []; // Default to an empty array if no data
      const total = response?.data?.total || 0; // Default to 0 if no total

      // Update the state with the fetched ingredients or empty state
      this.setState({
        stockData: stock,
        totalStock: total,
        totalItems: total,
        loading: false,
        addStockVisible: false,
        editStock: undefined,
        previewVisible: false,
        costVisible: false,
        roomsVisible: false,
        previewVisibleVariant: false,
        currentTab: 'All'
      });

      // Notify success with fallback for empty state
      if (stock.length === 0) {
        Notify('info', 'No data found', 'The database is currently empty.');
      } else {
        Notify('success', 'Deleted item', 'Successfully deleted item.');
      }
    } catch (e) {
      // Handle errors gracefully
      this.setState({ loading: false });
      Notify(
        'error',
        'Error deleting item',
        e.message || 'An unexpected error occurred.'
      );
    }
  };

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };
  handleChange = (pagination, filters, sorter) => {
    this.setState({
      sortedInfo: sorter
    });
  };
  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined style={{ color: filtered ? '#80CE90' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text =>
      text ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        ''
      )
  });

  handleSearchName = () => {
    if (this.state.siteSelected.length > 0) {
      // this.handleSelectFocus();
      this.setState({ loading: true }); // Set loading state to true before API call
      this.props
        .findAllStock(this.state.siteSelected)
        .then(response => {
          const { stock, total } = response.data; // Destructure total from response
          this.setState({
            loading: false,
            stockData: stock, // Update stockData with fetched data
            totalStock: total, // Set totalStock with the total count from the API
            currentPage: 1 // Reset to the first page when fetching new data
          });
        })
        .catch(e => {
          this.setState({ loading: false });
          Notify('error', e.message);
        });
    }
  };

  handlePageChange = page => {
    this.setState({ currentPage: page, loading: true }, () => {
      this.props
        .findAllStock(
          this.state.siteSelected,
          page,
          this.state.pageSize,
          this.state.searchText
        )
        .then(response => {
          const { stock, total } = response.data;
          this.setState({
            stockData: stock,
            totalStock: total,
            loading: false
          });
        })
        .catch(error => {
          this.setState({ loading: false });
          console.error('Page change failed', error);
        });
    });
  };

  handleCategoryChange = value => {
    this.setState({ selectedCategory: value || null }); // ✅ Reset to null when cleared
  };

  handleCategoryCostChange = value => {
    this.setState({ selectedCategoryCost: value });
  };

  handleCategoryRoomsChange = value => {
    this.setState({ selectedCategoryRooms: value });
  };

  handleMonthChange = (date, dateString) => {
    this.setState({ selectedYear: date ? date.format('YYYY') : null });
  };
  render() {
    const {
      open,
      openSteps,
      steps,
      selectedCategory,
      selectedCategoryCost,
      selectedCategoryRooms,
      selectedYear
    } = this.state;

    let descriptions = this.props.stock.map(vehicle => {
      return { value: vehicle.description };
    });
    const { collection, searchText } = this.state;
    const { stock } = this.props;
    let vehicles;
    if (this.state.currentTab === 'All') {
      vehicles = stock;
    } else {
      vehicles = stock.filter(
        vehicle => vehicle.collection === this.state.currentTab
      );
    }

    const filteredStockData = this.state.stockData.filter(
      item =>
        item.saleCategory &&
        (!this.state.selectedCategory ||
          item.saleCategory.includes(this.state.selectedCategory)) &&
        item.access &&
        this.state.siteSelected &&
        item.saleDate &&
        item.access.toLowerCase() === this.state.siteSelected.toLowerCase() &&
        (!this.state.selectedYear ||
          dayjs(item.saleDate).format('YYYY') === this.state.selectedYear)
    );
    const groupedData = Object.entries(
      filteredStockData.reduce((acc, item) => {
        const saleMonth = dayjs(item.saleDate).format('YYYY-MM'); // Group by month
        const saleDay = dayjs(item.saleDate).format('YYYY-MM-DD'); // Group by day

        if (!acc[saleMonth]) {
          acc[saleMonth] = {
            saleMonth,
            records: {},
            totals: {
              cashSales: 0,
              cardSales: 0,
              bednights: 0,
              refunds: 0,
              extraSales: 0,
              totalIncome: 0
            }
          };
        }

        if (!acc[saleMonth].records[saleDay]) {
          acc[saleMonth].records[saleDay] = {
            saleDay,
            records: [],
            totals: {
              cashSales: 0,
              cardSales: 0,
              bednights: 0,
              refunds: 0,
              extraSales: 0,
              totalIncome: 0
            }
          };
        }

        // **Apply category filtering**
        if (
          !this.state.selectedCategory ||
          item.saleCategory.includes(this.state.selectedCategory)
        ) {
          const sumArrayValues = (arr, categoryIndex = null) => {
            if (Array.isArray(arr)) {
              return categoryIndex !== null
                ? Number(arr[categoryIndex]) || 0
                : arr.reduce((sum, val) => sum + (val || 0), 0);
            }
            return 0;
          };
          let categoryIndex = null;
          if (this.state.selectedCategory && Array.isArray(item.saleCategory)) {
            categoryIndex = item.saleCategory.indexOf(
              this.state.selectedCategory
            );
          }

          const extraSalesTotal = sumArrayValues(
            item.extraSales,
            categoryIndex
          );

          const refundTotal = sumArrayValues(item.saleRefund, categoryIndex);

          const cashTotal = Number(item.saleCash) || 0;
          const cardTotal = Number(item.saleCard) || 0;

          const bednightsTotal = Number(item.saleBednights) || 0;

          acc[saleMonth].records[saleDay].records.push(item);

          // **Day-Level Totals**
          acc[saleMonth].records[saleDay].totals.extraSales += extraSalesTotal;
          acc[saleMonth].records[saleDay].totals.cashSales += cashTotal;
          acc[saleMonth].records[saleDay].totals.cardSales += cardTotal;
          acc[saleMonth].records[saleDay].totals.bednights += bednightsTotal;
          acc[saleMonth].records[saleDay].totals.refunds += refundTotal;
          acc[saleMonth].records[saleDay].totals.totalIncome +=
            extraSalesTotal - refundTotal - (cashTotal + cardTotal);

          // **Month-Level Totals**
          acc[saleMonth].totals.extraSales += extraSalesTotal;
          acc[saleMonth].totals.cashSales += cashTotal;
          acc[saleMonth].totals.cardSales += cardTotal;
          acc[saleMonth].totals.bednights += bednightsTotal;
          acc[saleMonth].totals.refunds += refundTotal;
          acc[saleMonth].totals.totalIncome +=
            extraSalesTotal - refundTotal - (cashTotal + cardTotal);
        }

        return acc;
      }, {})
    ).map(([_, group]) => group);

    const filteredStockDataCost = this.state.stockData.filter(
      item =>
        Array.isArray(item.costCategory) && // ✅ Ensure costCategory is an array
        item.access &&
        this.state.siteSelected &&
        item.costDate &&
        item.access.toLowerCase() === this.state.siteSelected.toLowerCase() &&
        (!this.state.selectedYear ||
          dayjs(item.costDate).format('YYYY') === this.state.selectedYear)
    );
    const groupedDataCost = Object.entries(
      filteredStockDataCost.reduce((acc, item) => {
        const costMonth = dayjs(item.costDate).format('YYYY-MM'); // Group by month
        const costDay = dayjs(item.costDate).format('YYYY-MM-DD'); // Group by day

        if (!acc[costMonth]) {
          acc[costMonth] = {
            costMonth,
            records: {},
            totals: {
              rooms: 0,
              roomsAvail: 0,
              roomsBlocked: 0,
              pax: 0,
              costPrice: 0,
              costBudget: 0,
              costPerPerson: 0,
              totalCost: 0,
              totalCostPerPAX: 0,
              totalOccupancy: 0 // ✅ Store cumulative occupancy
            }
          };
        }

        if (!acc[costMonth].records[costDay]) {
          acc[costMonth].records[costDay] = {
            costDay,
            records: [],
            totals: {
              rooms: 0,
              roomsAvail: 0,
              roomsBlocked: 0,
              pax: 0,
              costPrice: 0,
              costBudget: 0,
              costPerPerson: 0,
              totalCost: 0,
              totalCostPerPAX: 0,
              totalOccupancy: 0 // ✅ Store cumulative occupancy
            }
          };
        }
        if (
          !this.state.selectedCategoryCost ||
          (Array.isArray(item.costCategory) &&
            item.costCategory.includes(this.state.selectedCategoryCost))
        ) {
          // ✅ Helper Function to Sum Values (Handles both Arrays & Single Values)
          const sumValues = (value, categoryIndex = null) => {
            if (Array.isArray(value)) {
              return categoryIndex !== null && categoryIndex >= 0
                ? Number(value[categoryIndex]) || 0
                : value.reduce((sum, val) => sum + (Number(val) || 0), 0);
            }
            return Number(value) || 0; // ✅ If single value, return it
          };

          // ✅ Get Index of Selected Category (For Array Fields Only)
          let categoryIndex = null;
          if (
            this.state.selectedCategoryCost &&
            Array.isArray(item.costCategory)
          ) {
            categoryIndex = item.costCategory.indexOf(
              this.state.selectedCategoryCost
            );
            if (categoryIndex === -1) return acc; // ✅ Skip if category not found
          }

          // ✅ Correctly Extract Values (Handles Arrays & Non-Arrays)
          const costPriceTotal = sumValues(item.costPrice, categoryIndex);
          const costPerPersonTotal = sumValues(
            item.costPerPerson,
            categoryIndex
          );
          const costBudgetTotal = sumValues(item.costBudget);
          const paxTotal = sumValues(item.costPAX); // Not an array
          const roomsTotal = sumValues(item.costRooms); // Not an array
          const roomsAvailTotal = sumValues(item.costRoomsAvail); // Not an array
          const occupancyRate =
            roomsAvailTotal > 0 ? (roomsTotal / roomsAvailTotal) * 100 : 0;

          // ✅ Store the Item
          acc[costMonth].records[costDay].records.push(item);

          // ✅ Update Day-Level Totals (SUMS)
          acc[costMonth].records[costDay].totals.costPrice += costPriceTotal;
          acc[costMonth].records[
            costDay
          ].totals.costPerPerson += costPerPersonTotal;
          acc[costMonth].records[costDay].totals.totalCost += costPriceTotal;
          acc[costMonth].records[costDay].totals.totalCostPerPAX +=
            costPriceTotal / paxTotal;
          acc[costMonth].records[costDay].totals.pax += paxTotal;
          acc[costMonth].records[costDay].totals.costBudget += costBudgetTotal;
          acc[costMonth].records[costDay].totals.rooms += roomsTotal;
          acc[costMonth].records[costDay].totals.roomsAvail += roomsAvailTotal;
          acc[costMonth].records[costDay].totals.totalOccupancy += roomsTotal; // ✅ Accumulate booked rooms

          // ✅ Update Month-Level Totals (SUMS)
          acc[costMonth].totals.costPrice += costPriceTotal;
          acc[costMonth].totals.costPerPerson += costPerPersonTotal;
          acc[costMonth].totals.totalCost += costPriceTotal;
          acc[costMonth].totals.totalCostPerPAX += costPriceTotal / paxTotal;
          acc[costMonth].totals.costBudget += costBudgetTotal;
          acc[costMonth].totals.pax += paxTotal;
          acc[costMonth].totals.rooms += roomsTotal;
          acc[costMonth].totals.roomsAvail += roomsAvailTotal;
          acc[costMonth].totals.totalOccupancy += roomsTotal; // ✅ Accumulate booked rooms
        }
        return acc;
      }, {})
    ).map(([_, group]) => {
      // ✅ Calculate Final Averages at Month Level
      if (group.totals.roomsAvail > 0) {
        group.totals.occupancy = (
          (group.totals.totalOccupancy / group.totals.roomsAvail) *
          100
        ).toFixed(2);
      } else {
        group.totals.occupancy = 0; // ✅ Prevent NaN
      }

      // ✅ Calculate Final Averages at Day Level
      Object.values(group.records).forEach(dayRecord => {
        if (dayRecord.totals.roomsAvail > 0) {
          dayRecord.totals.occupancy = (
            (dayRecord.totals.totalOccupancy / dayRecord.totals.roomsAvail) *
            100
          ).toFixed(2);
        } else {
          dayRecord.totals.occupancy = 0; // ✅ Prevent NaN
        }
      });

      return group;
    });

    const groupedDataRooms = Object.entries(
      this.state.stockData
        .filter(
          item =>
            item.access &&
            this.state.siteSelected &&
            item.roomsDate &&
            item.access.toLowerCase() ===
              this.state.siteSelected.toLowerCase() &&
            (!this.state.selectedYear ||
              dayjs(item.roomsDate).format('YYYY') === this.state.selectedYear) // Month check
        ) // Filter items based on siteSelected
        .reduce((acc, item) => {
          const monthKey = item.roomsDate
            ? dayjs(item.roomsDate).format('YYYY-MM') // Group by month (e.g., 2024-11)
            : 'Unknown Month';

          if (!acc[monthKey]) {
            acc[monthKey] = {
              month: monthKey,
              roomsData: [], // Store individual records for the group
              totals: {
                roomsAvail: 0,
                roomsBooked: 0,
                roomsBlocked: 0,
                roomsPAX: 0,
                guideMeals: 0,
                refunds: 0,
                occupancy: 0
              }
            };
          }

          acc[monthKey].roomsData.push(item);

          // Aggregate totals for the group
          acc[monthKey].totals.roomsAvail += item.roomsAvail || 0;
          acc[monthKey].totals.roomsBooked += item.roomsBooked || 0;
          acc[monthKey].totals.roomsBlocked += item.roomsBlocked || 0;
          acc[monthKey].totals.roomsPAX += item.roomsPAX || 0;
          acc[monthKey].totals.guideMeals += Number(item.guideMeals) || 0;
          acc[monthKey].totals.refunds += item.roomsRefund || 0;

          // Calculate occupancy
          if (item.roomsAvail && item.roomsBooked) {
            const availableRooms = acc[monthKey].totals.roomsAvail || 0;
            const blockedRooms = acc[monthKey].totals.roomsBlocked || 0;

            if (availableRooms - blockedRooms > 0) {
              acc[monthKey].totals.occupancy = Math.round(
                (acc[monthKey].totals.roomsBooked /
                  (availableRooms - blockedRooms)) *
                  100
              );
            } else {
              acc[monthKey].totals.occupancy = 0; // Prevent division by zero
            }
          }

          return acc;
        }, {})
    )
      // Sort groups by month
      .sort(([monthA], [monthB]) => {
        if (monthA === 'Unknown Month') return 1; // Place 'Unknown Month' at the end
        if (monthB === 'Unknown Month') return -1;
        return new Date(monthA) - new Date(monthB); // Ascending order
      })
      .map(([_, group]) => group); // Extract grouped data

    const filteredData = groupedData.filter(item => {
      const matchesCategory =
        !selectedCategory || selectedCategory.includes(item.saleCategory);
      const matchesMonth =
        !selectedYear || dayjs(item.saleDate).format('YYYY') === selectedYear;

      return matchesCategory && matchesMonth;
    });
    const filteredDataCost = groupedDataCost.filter(item => {
      const matchesCategory =
        !selectedCategoryCost || item.costCategory === selectedCategoryCost;
      const matchesMonth =
        !selectedYear || dayjs(item.costDate).format('YYYY') === selectedYear;

      return matchesCategory && matchesMonth;
    });

    const filteredDataRooms = groupedDataRooms.filter(group => {
      const matchesCategory =
        !selectedCategoryRooms ||
        group.roomsData.some(
          item => item.roomsCategory === selectedCategoryRooms
        ); // Check category within grouped records

      const matchesMonth = !selectedYear || group.month === selectedYear; // Compare group month directly

      return matchesCategory && matchesMonth;
    });

    const matchesYearAndMonth = date => {
      const itemYear = dayjs(date).format('YYYY');
      const itemMonth = dayjs(date).format('MM');

      const selectedYear = this.state.selectedYear || dayjs().format('YYYY'); // Default to current year
      const selectedMonth = this.state.selectedMonth || dayjs().format('MM'); // Default to current month

      return itemYear === selectedYear && itemMonth === selectedMonth;
    };

    const filteredRooms = this.state.stockData.filter(
      item =>
        item.roomsDate &&
        matchesYearAndMonth(item.roomsDate) &&
        (this.state.siteSelected
          ? item.access === this.state.siteSelected
          : true)
    );
    const bednightsMTD = filteredRooms.reduce((sum, item) => {
      const roomsPAX = Array.isArray(item.roomsPAX)
        ? item.roomsPAX.reduce((total, val) => total + (Number(val) || 0), 0)
        : Number(item.roomsPAX) || 0;

      return sum + roomsPAX;
    }, 0);

    return (
      <div style={{ maxWidth: '90em', margin: 'auto' }}>
        <Spin spinning={this.state.loading}>
          <Tour
            open={openSteps}
            onClose={() => this.setState({ openSteps: false })}
            steps={steps}
          />

          {this.state.previewVisible ||
          this.state.costVisible ||
          this.state.roomsVisible ? (
            <Cards
              bordered={false}
              extra={
                <Title
                  style={{
                    paddingRight: '75em',
                    fontSize: '20px',
                    fontWeight: 800,
                    whiteSpace: 'nowrap',
                    fontFamily: 'Nunito'
                  }}
                >
                  {this.state.editStock ? 'Edit Item' : 'Add Item'}
                  <p
                    style={{
                      fontWeight: 400,
                      fontSize: '16px',
                      whiteSpace: 'nowrap',
                      marginTop: '0em',
                      marginBottom: '0em'
                    }}
                  >
                    {this.state.editStock
                      ? 'Complete all required fields and click Save to publish'
                      : 'Complete all required fields and click Save to publish'}
                  </p>
                </Title>
              }
              style={{
                margin: 'auto',
                marginTop: '0em',
                backgroundColor: 'white',
                borderRadius: '0.8em',
                boxShadow: '0px 6px 15px 0px rgba(0, 0, 0, 0.08)'
              }}
            >
              <div
                style={{
                  // padding: '3em',
                  // paddingTop: '1em',
                  // paddingBottom: '4em',
                  margin: 'auto'
                }}
              >
                <StockForm
                  bednightsMTD={bednightsMTD}
                  handleDeleteImage={this.handleDeleteImage}
                  handleDeleteImage2={this.handleDeleteImage2}
                  duplicateModal={this.state.duplicateModal}
                  siteSelected={this.state.siteSelected}
                  previewVisibleVariant={this.state.previewVisibleVariant}
                  previewVisible={this.state.previewVisible}
                  costVisible={this.state.costVisible}
                  roomsVisible={this.state.roomsVisible}
                  stock={this.state.stockData}
                  sites={this.props.sites}
                  editStock={this.state.editStock}
                  wrappedComponentRef={form => (this.stockForm = form)}
                />
                {/* <Tooltip placement="left" title="Back">
                  <FloatButton
                    style={{
                      right: 24,
                      bottom: '7.3em'
                    }}
                    onClick={e =>
                      this.setState({
                        siteSelected: this.state.siteSelected,
                        previewVisibleVariant: false,
                        previewVisible: false,
                        costVisible: false,
                        roomsVisible: false,
                        editStock: undefined
                      })
                    }
                    icon={<ArrowLeftOutlined style={{ color: 'black' }} />}
                  />
                </Tooltip> */}
                <FloatButton.Group
                  trigger="hover"
                  type="primary"
                  style={{
                    right: 24
                  }}
                  icon={<RocketFilled />}
                >
                  <Tooltip placement="left" title="Save Item">
                    <FloatButton
                      onClick={this.handleAddStock}
                      icon={<PlusCircleFilled style={{ color: '#80CE90' }} />}
                    />
                  </Tooltip>
                  <Tooltip placement="left" title="Cancel">
                    <FloatButton
                      onClick={e =>
                        this.setState({
                          siteSelected: this.state.siteSelected,
                          previewVisibleVariant: false,
                          previewVisible: false,
                          costVisible: false,
                          roomsVisible: false,
                          editStock: undefined
                        })
                      }
                      icon={<StopFilled style={{ color: 'red' }} />}
                    />
                  </Tooltip>
                </FloatButton.Group>
              </div>
            </Cards>
          ) : (
            <StyledTabs
              tabBarExtraContent={
                <>
                  <Tag
                    color="green"
                    style={{
                      marginBottom: '0em',
                      fontSize: '14px',
                      fontWeight: 600,
                      padding: '0.4em',
                      fontFamily: 'Nunito',
                      marginTop: '0.3em',
                      display: 'inline-block',
                      color: 'tgrey',
                      marginRight: '1em'
                    }}
                  >
                    PAX (MTD): {bednightsMTD}
                  </Tag>

                  <Select
                    size="large"
                    defaultValue={this.state.siteSelected} // Bind selected values to state
                    showSearch
                    onChange={values => {
                      this.setState({ siteSelected: values }, () => {
                        this.handleSearchName();
                      });
                    }}
                    style={{
                      marginRight: '1.2em',
                      width: '12em',
                      marginBottom: '1em'
                    }}
                    placeholder="Select Company"
                    optionFilterProp="children"
                  >
                    {/* <Select.Option key="Admin" value="Admin">
                          Admin
                        </Select.Option> */}
                    {/* Options for sites */}
                    {this.props.sites.map(site => (
                      <Option key={site._id} value={site._id}>
                        {site.name}
                      </Option>
                    ))}
                  </Select>

                  <DatePicker
                    picker="year"
                    size="large"
                    format="YYYY"
                    placeholder="Select Month"
                    onChange={this.handleMonthChange}
                    defaultValue={
                      this.state.selectedYear
                        ? dayjs(this.state.selectedYear)
                        : dayjs()
                    } // Automatically sets to the current month
                    style={{ marginRight: '1.2em', width: 140 }}
                    allowClear={false}
                  />
                </>
              }
              style={{ marginTop: '1em' }}
              animated={true}
              activeKey={this.state.activeTabKey} // Track the active tab
              onChange={activeKey => {
                this.setState({ activeTabKey: activeKey });
                localStorage.setItem('activeTabKey', activeKey); // Save the active tab key to localStorage
              }}
            >
              <TabPane tab="Variable Rooms" key="Variable Rooms">
                <Row style={{ marginTop: '1em' }}>
                  <Col span={6}>
                    <h1
                      style={{
                        marginBottom: '0em',
                        fontSize: '22px',
                        fontWeight: 800,
                        fontFamily: 'Nunito',
                        marginTop: '0.3em'
                      }}
                    >
                      Rooms Management
                    </h1>
                  </Col>
                  <Col span={18}>
                    <div style={{ float: 'right' }}>
                      {/* <Select
                        size="large"
                        defaultValue={this.state.siteSelected} // Bind selected values to state
                        showSearch

                        onChange={values => {
                          this.setState({ siteSelected: values }, () => {
                            this.handleSearchName();
                          });
                        }}
                        style={{ marginRight: '1.2em', width: '12em' }}
                        placeholder="Select Company"
                        optionFilterProp="children"
                      >

                        {this.props.sites.map(site => (
                          <Option key={site._id} value={site._id}>
                            {site.name}
                          </Option>
                        ))}
                      </Select>

                      <DatePicker
                        picker="year"
                        size="large"
                        format="YYYY"
                        placeholder="Select Month"
                        onChange={this.handleMonthChange}
                        defaultValue={this.state.selectedYear ? dayjs(this.state.selectedYear) : dayjs()}  // Automatically sets to the current month
                        style={{ marginRight: "1.2em", width: 140 }}
                        allowClear
                      /> */}

                      <Button
                        ref={this.ref}
                        type="primary"
                        onClick={this.onAddStockRooms}
                        icon={<PlusCircleFilled style={{ fontSize: '110%' }} />}
                        size="large"
                        style={
                          {
                            // marginBottom: '1em',
                          }
                        }
                      >
                        Add Rooms
                      </Button>
                    </div>
                  </Col>

                  <Col span={24}>
                    <StyledTable
                      bordered={false}
                      dataSource={groupedDataRooms} // Use filtered data for the table
                      // pagination={{
                      //   current: this.state.currentPage,
                      //   pageSize: this.state.pageSize,
                      //   total: groupedDataRooms.length, // Total groups after filtering
                      //   onChange: this.handlePageChange,
                      // }}
                      rowKey={record => `${record.month}-${record._id}`}
                      size="middle"
                      style={{
                        minWidth: '15em',
                        marginTop: '1em'
                      }}
                      scroll={{
                        x: 800
                      }}
                      expandable={{
                        expandedRowRender: group => (
                          <StyledTableExpanded
                            dataSource={group.roomsData}
                            pagination={false}
                            rowKey={item => item._id}
                            columns={[
                              {
                                title: 'Date',
                                dataIndex: 'roomsDate',
                                key: 'roomsDate',
                                render: (text, record) =>
                                  record.roomsDate !== 'Unknown Date' ? (
                                    dayjs(record.roomsDate).format('DD-MM-YYYY')
                                  ) : (
                                    <div>No Date</div>
                                  )
                              },
                              {
                                title: 'Staff Ons Site',
                                dataIndex: 'staffOnSite',
                                key: 'staffOnSite'
                              },
                              {
                                title: 'Rooms Available',
                                dataIndex: 'roomsAvail',
                                key: 'roomsAvail'
                              },
                              {
                                title: 'Rooms Booked',
                                dataIndex: 'roomsBooked',
                                key: 'roomsBooked'
                              },
                              {
                                title: 'Rooms Blocked',
                                dataIndex: 'roomsBlocked',
                                key: 'roomsBlocked'
                              },
                              {
                                title: 'Rooms PAX',
                                dataIndex: 'roomsPAX',
                                key: 'roomsPAX'
                              },
                              {
                                title: 'Guide Meals',
                                dataIndex: 'guideMeals',
                                key: 'guideMeals'
                              },
                              {
                                title: 'Occupancy %',
                                dataIndex: 'roomOccupancy',
                                key: 'roomOccupancy',
                                render: (text, record) => {
                                  const value = record.roomOccupancy; // Extract the value
                                  return (
                                    <span>
                                      {value != null && !isNaN(value)
                                        ? `${value.toFixed(0)}%`
                                        : '-'}{' '}
                                      {/* Check if value is valid */}
                                    </span>
                                  );
                                }
                              },
                              // {
                              //   title: 'Category',
                              //   dataIndex: 'saleCategory',
                              //   key: 'saleCategory',
                              // },

                              {
                                title: 'Actions',
                                fixed: 'right',
                                render: (text, stock) => (
                                  <span>
                                    <Tooltip
                                      placement="top"
                                      title="Edit Details"
                                    >
                                      <EditFilled
                                        style={{
                                          backgroundColor: '#80CE90',
                                          color: 'white',
                                          padding: '0.5em',
                                          borderRadius: '3em'
                                        }}
                                        onClick={e => {
                                          e.stopPropagation(); // Prevent row click event
                                          this.handleEditStockRooms(stock);
                                        }}
                                      />
                                    </Tooltip>

                                    <Divider type="vertical" />
                                    <Tooltip
                                      placement="top"
                                      title="Delete Sale"
                                    >
                                      <DeleteFilled
                                        style={{
                                          backgroundColor: 'crimson',
                                          color: 'white',
                                          padding: '0.5em',
                                          borderRadius: '3em'
                                        }}
                                        onClick={e => {
                                          e.stopPropagation(); // Prevent row click event
                                          this.setState({
                                            deleteVisible: true,
                                            deleteStock: stock
                                          });
                                        }}
                                      />
                                    </Tooltip>
                                  </span>
                                )
                              }
                            ]}
                          />
                        )
                      }}
                    >
                      <Column
                        title="Month"
                        dataIndex="month"
                        key="month"
                        render={month => dayjs(month).format('MMM YYYY')}
                      />
                      <Column
                        title="Total Rooms Available"
                        dataIndex={['totals', 'roomsAvail']}
                        key="roomsAvail"
                      />
                      <Column
                        title="Total Rooms Booked"
                        dataIndex={['totals', 'roomsBooked']}
                        key="roomsBooked"
                      />
                      <Column
                        title="Total Rooms Blocked"
                        dataIndex={['totals', 'roomsBlocked']}
                        key="roomsBlocked"
                      />
                      <Column
                        title="Total PAX"
                        dataIndex={['totals', 'roomsPAX']}
                        key="roomsPAX"
                      />
                      <Column
                        title="Total Guide Meals"
                        dataIndex={['totals', 'guideMeals']}
                        key="guideMeals"
                      />
                      <Column
                        title="Occupancy %"
                        dataIndex={['totals', 'occupancy']}
                        key="occupancy"
                        render={value =>
                          value != null ? `${value.toFixed(0)}%` : '-'
                        }
                      />
                    </StyledTable>
                  </Col>
                </Row>
              </TabPane>

              <TabPane tab="Sales" key="Sales">
                <Row style={{ marginTop: '1em' }}>
                  <Col span={6}>
                    <h1
                      style={{
                        marginBottom: '0em',
                        fontSize: '22px',
                        fontWeight: 800,
                        fontFamily: 'Nunito',
                        marginTop: '0.3em'
                      }}
                    >
                      Sales Management
                    </h1>
                  </Col>
                  <Col span={18}>
                    <div style={{ float: 'right' }}>
                      {/* <Select
                        size="large"
                        defaultValue={this.state.siteSelected} // Bind selected values to state
                        showSearch

                        onChange={values => {
                          this.setState({ siteSelected: values }, () => {
                            this.handleSearchName();
                          });
                        }}
                        style={{ marginRight: '1.2em', width: '12em' }}
                        placeholder="Select Company"
                        optionFilterProp="children"
                      >
  
  
                        {this.props.sites.map(site => (
                          <Option key={site._id} value={site._id}>
                            {site.name}
                          </Option>
                        ))}
                      </Select> */}
                      <Select
                        size="large"
                        // mode="multiple"
                        allowClear
                        placeholder="Category"
                        value={this.state.selectedCategory} // Sync state to selected value
                        onChange={this.handleCategoryChange}
                        style={{ marginRight: '1.2em', width: '12em' }}
                      >
                        {[
                          ...new Set(
                            this.props.sites.flatMap(
                              site => site.saleCategories || []
                            )
                          )
                        ].map(category => (
                          <Option key={category} value={category}>
                            {category}
                          </Option>
                        ))}
                      </Select>

                      {/* <DatePicker
                        picker="year"
                        size="large"
                        format="YYYY"
                        placeholder="Select Month"
                        onChange={this.handleMonthChange}
                        defaultValue={this.state.selectedYear ? dayjs(this.state.selectedYear) : dayjs()}  // Automatically sets to the current month
                        style={{ marginRight: "1.2em", width: 140 }}
                        allowClear
                      /> */}
                      {/* <Search
                    size="large"
                    placeholder="Search Product"
                    allowClear
                    onSearch={this.handleSearchProduct}
                    enterButton
                    style={{ marginRight: '1.2em', width: '20em' }}
                    defaultValue={this.state.searchText}
                  /> */}
                      <Button
                        ref={this.ref}
                        type="primary"
                        onClick={this.onAddStock}
                        icon={<PlusCircleFilled style={{ fontSize: '110%' }} />}
                        size="large"
                        style={
                          {
                            // marginBottom: '1em',
                          }
                        }
                      >
                        Add Sale
                      </Button>
                      {/* <Button
                    size="large"
                    onClick={() => this.setState({ openSteps: true })}
                    style={{ marginLeft: '1em' }}
                  >
                    <InfoCircleFilled />
                  </Button> */}
                    </div>
                  </Col>

                  <Col span={24}>
                    <StyledTable
                      bordered={false}
                      dataSource={groupedData}
                      rowKey="saleMonth"
                      style={{ marginTop: '1em' }}
                      pagination={false}
                      expandable={{
                        expandedRowRender: monthRecord => (
                          <StyledTable
                            bordered={false}
                            dataSource={Object.values(monthRecord.records)}
                            rowKey="saleDay"
                            pagination={false}
                            expandable={{
                              expandedRowRender: dayRecord => (
                                <StyledTableExpanded
                                  dataSource={dayRecord.records}
                                  pagination={false}
                                  rowKey={item => item._id}
                                  expandable={{
                                    expandedRowRender: record => {
                                      const {
                                        saleCategory,
                                        extraSales,
                                        saleRefund,
                                        saleComments
                                      } = record;
                                      if (!Array.isArray(saleCategory))
                                        return null;

                                      // ✅ Ensure category selection filters correctly
                                      const filteredExpandedData = saleCategory
                                        .map((category, index) => ({
                                          key: `${record._id}-${category}`,
                                          category,
                                          extraSales: extraSales?.[index] || 0,
                                          saleRefund: saleRefund?.[index] || 0,
                                          saleComments:
                                            saleComments?.[index] ||
                                            'No Comments'
                                        }))
                                        .filter(
                                          item =>
                                            !this.state.selectedCategory ||
                                            item.category ===
                                              this.state.selectedCategory
                                        ); // ✅ Filter by selected category

                                      // ✅ If no data after filtering, return nothing
                                      if (filteredExpandedData.length === 0)
                                        return null;

                                      return (
                                        <StyledTable
                                          dataSource={filteredExpandedData}
                                          pagination={false}
                                          rowKey="key"
                                          columns={[
                                            {
                                              title: 'Category',
                                              dataIndex: 'category',
                                              key: 'category'
                                            },
                                            {
                                              title: 'Extra Sales',
                                              dataIndex: 'extraSales',
                                              key: 'extraSales',
                                              render: text => {
                                                const companyCurrency =
                                                  this.props.sites.find(
                                                    site =>
                                                      site._id ===
                                                      this.state.siteSelected
                                                  )?.companyCurrency || 'R';

                                                return `${companyCurrency} ${new Intl.NumberFormat(
                                                  'en-US',
                                                  {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                  }
                                                ).format(Number(text) || 0)}`;
                                              }
                                            },
                                            {
                                              title: 'Complimentary / Refund',
                                              dataIndex: 'saleRefund',
                                              key: 'saleRefund',
                                              render: text => {
                                                const companyCurrency =
                                                  this.props.sites.find(
                                                    site =>
                                                      site._id ===
                                                      this.state.siteSelected
                                                  )?.companyCurrency || 'R';

                                                // Format the number with thousand separators and two decimals
                                                const formattedValue = new Intl.NumberFormat(
                                                  'en-US',
                                                  {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                  }
                                                ).format(Number(text) || 0);

                                                return text > 0 ? (
                                                  <Tag color="red">{`${companyCurrency} ${formattedValue}`}</Tag>
                                                ) : (
                                                  'N/A'
                                                );
                                              }
                                            },
                                            {
                                              title: 'Comments',
                                              dataIndex: 'saleComments',
                                              key: 'saleComments'
                                            }
                                          ]}
                                        />
                                      );
                                    }
                                  }}
                                  columns={[
                                    {
                                      title: 'Booking Number',
                                      dataIndex: 'bookingNr',
                                      key: 'bookingNr'
                                      // render: (text) => {
                                      //   if (Array.isArray(text)) {
                                      //     return text.includes(this.state.selectedCategory) ? this.state.selectedCategory : text.join(", ");
                                      //   }
                                      //   return text;
                                      // },
                                    },
                                    // {
                                    //   title: "Category",
                                    //   dataIndex: "saleCategory",
                                    //   key: "saleCategory",
                                    //   render: (text) => {
                                    //     if (Array.isArray(text)) {
                                    //       return text.includes(this.state.selectedCategory) ? this.state.selectedCategory : text.join(", ");
                                    //     }
                                    //     return text;
                                    //   },
                                    // },
                                    {
                                      title: 'Extra Sales',
                                      dataIndex: 'extraSales',
                                      key: 'extraSales',
                                      render: (text, record) => {
                                        const selectedCategory = this.state
                                          .selectedCategory;
                                        let totalExtraSales = 0;

                                        // ✅ If no category is selected, sum ALL values
                                        if (!selectedCategory) {
                                          totalExtraSales = Array.isArray(
                                            record.extraSales
                                          )
                                            ? record.extraSales.reduce(
                                                (sum, value) =>
                                                  sum + (Number(value) || 0),
                                                0
                                              )
                                            : Number(record.extraSales) || 0;
                                        }
                                        // ✅ If a category is selected, filter accordingly
                                        else if (
                                          Array.isArray(record.extraSales) &&
                                          Array.isArray(record.saleCategory)
                                        ) {
                                          totalExtraSales = record.saleCategory.reduce(
                                            (sum, category, index) => {
                                              return category ===
                                                selectedCategory
                                                ? sum +
                                                    (Number(
                                                      record.extraSales[index]
                                                    ) || 0)
                                                : sum;
                                            },
                                            0
                                          );
                                        } else {
                                          totalExtraSales =
                                            Number(record.extraSales) || 0;
                                        }

                                        const companyCurrency =
                                          this.props.sites.find(
                                            site =>
                                              site._id ===
                                              this.state.siteSelected
                                          )?.companyCurrency || 'R';

                                        // ✅ Format the number properly
                                        return `${companyCurrency} ${totalExtraSales.toLocaleString(
                                          'en-US',
                                          {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                          }
                                        )}`;
                                      }
                                    },
                                    {
                                      title: 'Cash',
                                      dataIndex: 'saleCash',
                                      key: 'saleCash',
                                      render: text => {
                                        const cashValue = Array.isArray(text)
                                          ? text.reduce(
                                              (sum, value) =>
                                                sum + (Number(value) || 0),
                                              0
                                            )
                                          : Number(text) || 0;
                                        const companyCurrency =
                                          this.props.sites.find(
                                            site =>
                                              site._id ===
                                              this.state.siteSelected
                                          )?.companyCurrency || 'R';

                                        // ✅ Format the number properly
                                        return `${companyCurrency} ${cashValue.toLocaleString(
                                          'en-US',
                                          {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                          }
                                        )}`;
                                      }
                                    },
                                    {
                                      title: 'Card',
                                      dataIndex: 'saleCard',
                                      key: 'saleCard',
                                      render: text => {
                                        const cardValue = Array.isArray(text)
                                          ? text.reduce(
                                              (sum, value) =>
                                                sum + (Number(value) || 0),
                                              0
                                            )
                                          : Number(text) || 0;
                                        const companyCurrency =
                                          this.props.sites.find(
                                            site =>
                                              site._id ===
                                              this.state.siteSelected
                                          )?.companyCurrency || 'R';

                                        // ✅ Format the number properly
                                        return `${companyCurrency} ${cardValue.toLocaleString(
                                          'en-US',
                                          {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                          }
                                        )}`;
                                      }
                                    },
                                    {
                                      title: 'Complimentary / Refund',
                                      dataIndex: 'saleRefund',
                                      key: 'saleRefund',
                                      render: (text, record) => {
                                        const selectedCategory = this.state
                                          .selectedCategory;
                                        let totalRefunds = 0;

                                        // ✅ If no category is selected, sum ALL values
                                        if (!selectedCategory) {
                                          totalRefunds = Array.isArray(
                                            record.saleRefund
                                          )
                                            ? record.saleRefund.reduce(
                                                (sum, value) =>
                                                  sum + (Number(value) || 0),
                                                0
                                              )
                                            : Number(record.saleRefund) || 0;
                                        }
                                        // ✅ If a category is selected, filter accordingly
                                        else if (
                                          Array.isArray(record.saleRefund) &&
                                          Array.isArray(record.saleCategory)
                                        ) {
                                          totalRefunds = record.saleCategory.reduce(
                                            (sum, category, index) => {
                                              return category ===
                                                selectedCategory
                                                ? sum +
                                                    (Number(
                                                      record.saleRefund[index]
                                                    ) || 0)
                                                : sum;
                                            },
                                            0
                                          );
                                        } else {
                                          totalRefunds =
                                            Number(record.saleRefund) || 0;
                                        }

                                        const companyCurrency =
                                          this.props.sites.find(
                                            site =>
                                              site._id ===
                                              this.state.siteSelected
                                          )?.companyCurrency || 'R';

                                        // ✅ Format the number properly and apply red tag only if refund exists
                                        return totalRefunds > 0 ? (
                                          <Tag color="red">{`${companyCurrency} ${totalRefunds.toLocaleString(
                                            'en-US',
                                            {
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2
                                            }
                                          )}`}</Tag>
                                        ) : null;
                                      }
                                    },

                                    {
                                      title: 'Bednights',
                                      dataIndex: 'saleBednights',
                                      key: 'saleBednights',
                                      render: text => {
                                        const bednightsValue = Array.isArray(
                                          text
                                        )
                                          ? text.reduce(
                                              (sum, value) =>
                                                sum + (Number(value) || 0),
                                              0
                                            )
                                          : Number(text) || 0;

                                        return bednightsValue || 0;
                                      }
                                    },
                                    {
                                      title: 'Balance',
                                      dataIndex: 'balance',
                                      key: 'balance',
                                      render: (text, record) => {
                                        const selectedCategory = this.state
                                          .selectedCategory;
                                        let totalExtraSales = 0;
                                        let cashValue = 0;
                                        let cardValue = 0;
                                        let refundValue = 0;

                                        // ✅ Calculate Total Extra Sales
                                        if (!selectedCategory) {
                                          totalExtraSales = Array.isArray(
                                            record.extraSales
                                          )
                                            ? record.extraSales.reduce(
                                                (sum, value) =>
                                                  sum + (Number(value) || 0),
                                                0
                                              )
                                            : Number(record.extraSales) || 0;
                                        } else if (
                                          Array.isArray(record.extraSales) &&
                                          Array.isArray(record.saleCategory)
                                        ) {
                                          totalExtraSales = record.saleCategory.reduce(
                                            (sum, category, index) => {
                                              return category ===
                                                selectedCategory
                                                ? sum +
                                                    (Number(
                                                      record.extraSales[index]
                                                    ) || 0)
                                                : sum;
                                            },
                                            0
                                          );
                                        } else {
                                          totalExtraSales =
                                            Number(record.extraSales) || 0;
                                        }

                                        // ✅ Calculate Total Cash
                                        cashValue = Array.isArray(
                                          record.saleCash
                                        )
                                          ? record.saleCash.reduce(
                                              (sum, value) =>
                                                sum + (Number(value) || 0),
                                              0
                                            )
                                          : Number(record.saleCash) || 0;

                                        // ✅ Calculate Total Card
                                        cardValue = Array.isArray(
                                          record.saleCard
                                        )
                                          ? record.saleCard.reduce(
                                              (sum, value) =>
                                                sum + (Number(value) || 0),
                                              0
                                            )
                                          : Number(record.saleCard) || 0;

                                        refundValue = Array.isArray(
                                          record.saleRefund
                                        )
                                          ? record.saleRefund.reduce(
                                              (sum, value) =>
                                                sum + (Number(value) || 0),
                                              0
                                            )
                                          : Number(record.saleRefund) || 0;

                                        // ✅ Compute Balance
                                        const balance =
                                          totalExtraSales -
                                          (cashValue + cardValue + refundValue);

                                        const companyCurrency =
                                          this.props.sites.find(
                                            site =>
                                              site._id ===
                                              this.state.siteSelected
                                          )?.companyCurrency || 'R';

                                        // ✅ Format as Currency
                                        return `${companyCurrency} ${balance.toLocaleString(
                                          'en-US',
                                          {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                          }
                                        )}`;
                                      }
                                    },

                                    {
                                      title: 'Actions',
                                      fixed: 'right',
                                      render: (text, record) => (
                                        <span>
                                          <Tooltip placement="top" title="Edit">
                                            <EditFilled
                                              style={{
                                                backgroundColor: '#80CE90',
                                                color: 'white',
                                                padding: '0.5em',
                                                borderRadius: '3em'
                                              }}
                                              onClick={e =>
                                                this.handleEditStock(record)
                                              }
                                            />
                                          </Tooltip>
                                          <Divider type="vertical" />
                                          <Tooltip
                                            placement="top"
                                            title="Delete"
                                          >
                                            <DeleteFilled
                                              style={{
                                                backgroundColor: 'crimson',
                                                color: 'white',
                                                padding: '0.5em',
                                                borderRadius: '3em'
                                              }}
                                              onClick={e => {
                                                e.stopPropagation(); // Prevent row click event
                                                this.setState({
                                                  deleteVisible: true,
                                                  deleteStock: record
                                                });
                                              }}
                                            />
                                          </Tooltip>
                                        </span>
                                      )
                                    }
                                  ]}
                                />
                              )
                            }}
                            columns={[
                              {
                                title: 'Day',
                                dataIndex: 'saleDay',
                                key: 'saleDay',
                                render: text => dayjs(text).format('DD-MM-YYYY')
                              },
                              {
                                title: 'Extra Sales',
                                dataIndex: ['totals', 'extraSales'],
                                key: 'extraSales',
                                render: text => {
                                  const companyCurrency =
                                    this.props.sites.find(
                                      site =>
                                        site._id === this.state.siteSelected
                                    )?.companyCurrency || 'R';

                                  return `${companyCurrency} ${new Intl.NumberFormat(
                                    'en-US',
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    }
                                  ).format(Number(text) || 0)}`;
                                }
                              },
                              {
                                title: 'Cash',
                                dataIndex: ['totals', 'cashSales'],
                                key: 'cashSales',
                                render: text => {
                                  const companyCurrency =
                                    this.props.sites.find(
                                      site =>
                                        site._id === this.state.siteSelected
                                    )?.companyCurrency || 'R';

                                  return `${companyCurrency} ${new Intl.NumberFormat(
                                    'en-US',
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    }
                                  ).format(Number(text) || 0)}`;
                                }
                              },

                              {
                                title: 'Card',
                                dataIndex: ['totals', 'cardSales'],
                                key: 'cardSales',
                                render: text => {
                                  const companyCurrency =
                                    this.props.sites.find(
                                      site =>
                                        site._id === this.state.siteSelected
                                    )?.companyCurrency || 'R';

                                  return `${companyCurrency} ${new Intl.NumberFormat(
                                    'en-US',
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    }
                                  ).format(Number(text) || 0)}`;
                                }
                              },

                              {
                                title: 'Complimentary / Refund',
                                dataIndex: ['totals', 'refunds'],
                                key: 'refunds',
                                render: text => {
                                  const companyCurrency =
                                    this.props.sites.find(
                                      site =>
                                        site._id === this.state.siteSelected
                                    )?.companyCurrency || 'R';

                                  // Format the number with thousand separators and two decimals
                                  const formattedValue = new Intl.NumberFormat(
                                    'en-US',
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    }
                                  ).format(Number(text) || 0);

                                  return text > 0 ? (
                                    <Tag color="red">{`${companyCurrency} ${formattedValue}`}</Tag>
                                  ) : (
                                    'N/A'
                                  );
                                }
                              },
                              {
                                title: 'Bednights',
                                dataIndex: ['totals', 'bednights'],
                                key: 'bednights',
                                render: text => text || 0
                              },
                              {
                                title: 'Balance',
                                dataIndex: ['totals', 'totalIncome'],
                                key: 'totalIncome',
                                render: text => {
                                  const companyCurrency =
                                    this.props.sites.find(
                                      site =>
                                        site._id === this.state.siteSelected
                                    )?.companyCurrency || 'R';

                                  return `${companyCurrency} ${new Intl.NumberFormat(
                                    'en-US',
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    }
                                  ).format(Number(text) || 0)}`;
                                }
                              }
                            ]}
                          />
                        )
                      }}
                      columns={[
                        {
                          title: 'Month',
                          dataIndex: 'saleMonth',
                          key: 'saleMonth',
                          render: text => dayjs(text).format('MMM YYYY')
                        },
                        {
                          title: 'Extra Sales',
                          dataIndex: ['totals', 'extraSales'],
                          key: 'extraSales',
                          render: text => {
                            const companyCurrency =
                              this.props.sites.find(
                                site => site._id === this.state.siteSelected
                              )?.companyCurrency || 'R';

                            return `${companyCurrency} ${new Intl.NumberFormat(
                              'en-US',
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              }
                            ).format(Number(text) || 0)}`;
                          }
                        },
                        {
                          title: 'Cash',
                          dataIndex: ['totals', 'cashSales'],
                          key: 'cashSales',
                          render: text => {
                            const companyCurrency =
                              this.props.sites.find(
                                site => site._id === this.state.siteSelected
                              )?.companyCurrency || 'R';

                            return `${companyCurrency} ${new Intl.NumberFormat(
                              'en-US',
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              }
                            ).format(Number(text) || 0)}`;
                          }
                        },
                        {
                          title: 'Card',
                          dataIndex: ['totals', 'cardSales'],
                          key: 'cardSales',
                          render: text => {
                            const companyCurrency =
                              this.props.sites.find(
                                site => site._id === this.state.siteSelected
                              )?.companyCurrency || 'R';

                            return `${companyCurrency} ${new Intl.NumberFormat(
                              'en-US',
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              }
                            ).format(Number(text) || 0)}`;
                          }
                        },

                        {
                          title: 'Complimentary / Refund',
                          dataIndex: ['totals', 'refunds'],
                          key: 'refunds',
                          render: text => {
                            const companyCurrency =
                              this.props.sites.find(
                                site => site._id === this.state.siteSelected
                              )?.companyCurrency || 'R';

                            // Format the number with thousand separators and two decimals
                            const formattedValue = new Intl.NumberFormat(
                              'en-US',
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              }
                            ).format(Number(text) || 0);

                            return text > 0 ? (
                              <Tag color="red">{`${companyCurrency} ${formattedValue}`}</Tag>
                            ) : (
                              'N/A'
                            );
                          }
                        },
                        {
                          title: 'Bednights',
                          dataIndex: ['totals', 'bednights'],
                          key: 'bednights',
                          render: text => text || 0
                        },
                        {
                          title: 'Balance',
                          dataIndex: ['totals', 'totalIncome'],
                          key: 'totalIncome',
                          render: text => {
                            const companyCurrency =
                              this.props.sites.find(
                                site => site._id === this.state.siteSelected
                              )?.companyCurrency || 'R';

                            return `${companyCurrency} ${new Intl.NumberFormat(
                              'en-US',
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              }
                            ).format(Number(text) || 0)}`;
                          }
                        }
                      ]}
                    />
                  </Col>
                </Row>
              </TabPane>

              <TabPane tab="Variable Cost" key="Variable Cost">
                <Row style={{ marginTop: '1em' }}>
                  <Col span={6}>
                    <h1
                      style={{
                        marginBottom: '0em',
                        fontSize: '22px',
                        fontWeight: 800,
                        fontFamily: 'Nunito',
                        marginTop: '0.3em'
                      }}
                    >
                      Cost Management
                    </h1>
                  </Col>
                  <Col span={18}>
                    <div style={{ float: 'right' }}>
                      {/* <Select
                        size="large"
                        defaultValue={this.state.siteSelected} // Bind selected values to state
                        showSearch

                        onChange={values => {
                          this.setState({ siteSelected: values }, () => {
                            this.handleSearchName();
                          });
                        }}
                        style={{ marginRight: '1.2em', width: '12em' }}
                        placeholder="Select Company"
                        optionFilterProp="children"
                      >

                        {this.props.sites.map(site => (
                          <Option key={site._id} value={site._id}>
                            {site.name}
                          </Option>
                        ))}
                      </Select> */}
                      <Select
                        size="large"
                        style={{ marginRight: '1.2em', width: '12em' }}
                        placeholder="Category"
                        onChange={this.handleCategoryCostChange}
                        allowClear
                      >
                        {/* Dynamically create options based on unique categories */}
                        {/* {[...new Set(groupedData.map(item => item.saleCategory))].map(category => (
                          <Option key={category} value={category}>
                            {category}
                          </Option>
                        ))} */}
                        {/* Ensure saleCategories is an array and flatten if needed */}
                        {[
                          ...new Set(
                            this.props.sites.flatMap(
                              site => site.costCategories || []
                            )
                          )
                        ].map(category => (
                          <Option key={category} value={category}>
                            {category}
                          </Option>
                        ))}
                      </Select>
                      {/* <DatePicker
                        picker="year"
                        size="large"
                        format="YYYY"
                        placeholder="Select Month"
                        onChange={this.handleMonthChange}
                        defaultValue={this.state.selectedYear ? dayjs(this.state.selectedYear) : dayjs()}  // Automatically sets to the current month
                        style={{ marginRight: "1.2em", width: 140 }}
                        allowClear
                      /> */}

                      <Button
                        ref={this.ref}
                        type="primary"
                        onClick={this.onAddStockCost}
                        icon={<PlusCircleFilled style={{ fontSize: '110%' }} />}
                        size="large"
                        style={
                          {
                            // marginBottom: '1em',
                          }
                        }
                      >
                        Add Cost
                      </Button>
                    </div>
                  </Col>

                  <Col span={24}>
                    <StyledTable
                      bordered={false}
                      dataSource={groupedDataCost}
                      rowKey="costMonth"
                      style={{ marginTop: '1em' }}
                      pagination={false}
                      expandable={{
                        expandedRowRender: monthRecord => (
                          <StyledTable
                            bordered={false}
                            dataSource={Object.values(monthRecord.records)}
                            rowKey="costDay"
                            pagination={false}
                            expandable={{
                              expandedRowRender: dayRecord => {
                                console.log(
                                  '✅ Debugging `dayRecord.records` structure:',
                                  dayRecord.records
                                );

                                if (
                                  !dayRecord.records ||
                                  dayRecord.records.length === 0
                                )
                                  return null;

                                // 🟡 Ensure `_id` exists in each record
                                dayRecord.records.forEach(record => {
                                  console.log(
                                    `🟡 Checking record: ${
                                      record._id
                                    } | Categories: ${record.costCategory}`
                                  );
                                });

                                const categoryData = dayRecord.records.flatMap(
                                  record =>
                                    Array.isArray(record.costCategory)
                                      ? record.costCategory.map(
                                          (category, index) => ({
                                            key: `${record._id}-${category}`,
                                            category,
                                            costPrice: Array.isArray(
                                              record.costPrice
                                            )
                                              ? record.costPrice[index]
                                              : record.costPrice,
                                            costPerPerson: Array.isArray(
                                              record.costPerPerson
                                            )
                                              ? record.costPerPerson[index]
                                              : record.costPerPerson,
                                            costComments: Array.isArray(
                                              record.costComments
                                            )
                                              ? record.costComments[index]
                                              : record.costComments
                                          })
                                        )
                                      : []
                                );

                                if (categoryData.length === 0)
                                  return (
                                    <p style={{ paddingLeft: '1em' }}>
                                      No categories available
                                    </p>
                                  );

                                return (
                                  <StyledTable
                                    dataSource={categoryData}
                                    pagination={false}
                                    rowKey="key"
                                    columns={[
                                      {
                                        title: 'Category',
                                        dataIndex: 'category',
                                        key: 'category'
                                      },
                                      {
                                        title: 'Cost P/Person',
                                        dataIndex: 'costPerPerson',
                                        key: 'costPerPerson',
                                        render: (text, record) => {
                                          const selectedCategory = this.state
                                            .selectedCategory;
                                          let totalCostPerPerson = 0;

                                          // ✅ If no category is selected, sum ALL values
                                          if (!selectedCategory) {
                                            totalCostPerPerson = Array.isArray(
                                              record.costPerPerson
                                            )
                                              ? record.costPerPerson.reduce(
                                                  (sum, value) =>
                                                    sum + (Number(value) || 0),
                                                  0
                                                )
                                              : Number(record.costPerPerson) ||
                                                0;
                                          }
                                          // ✅ If a category is selected, filter accordingly
                                          else if (
                                            Array.isArray(
                                              record.costPerPerson
                                            ) &&
                                            Array.isArray(record.costCategory)
                                          ) {
                                            totalCostPerPerson = record.costCategory.reduce(
                                              (sum, category, index) => {
                                                return category ===
                                                  selectedCategory
                                                  ? sum +
                                                      (Number(
                                                        record.costPerPerson[
                                                          index
                                                        ]
                                                      ) || 0)
                                                  : sum;
                                              },
                                              0
                                            );
                                          } else {
                                            totalCostPerPerson =
                                              Number(record.costPerPerson) || 0;
                                          }

                                          const companyCurrency =
                                            this.props.sites.find(
                                              site =>
                                                site._id ===
                                                this.state.siteSelected
                                            )?.companyCurrency || 'R';

                                          // ✅ Format the number properly
                                          return `${companyCurrency} ${totalCostPerPerson.toLocaleString(
                                            'en-US',
                                            {
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2
                                            }
                                          )}`;
                                        }
                                      },
                                      {
                                        title: 'Cost',
                                        dataIndex: 'costPrice',
                                        key: 'costPrice',
                                        render: (text, record) => {
                                          const selectedCategory = this.state
                                            .selectedCategory;
                                          let totalCost = 0;

                                          // ✅ If no category is selected, sum ALL values
                                          if (!selectedCategory) {
                                            totalCost = Array.isArray(
                                              record.costPrice
                                            )
                                              ? record.costPrice.reduce(
                                                  (sum, value) =>
                                                    sum + (Number(value) || 0),
                                                  0
                                                )
                                              : Number(record.costPrice) || 0;
                                          }
                                          // ✅ If a category is selected, filter accordingly
                                          else if (
                                            Array.isArray(record.costPrice) &&
                                            Array.isArray(record.costCategory)
                                          ) {
                                            totalCost = record.costCategory.reduce(
                                              (sum, category, index) => {
                                                return category ===
                                                  selectedCategory
                                                  ? sum +
                                                      (Number(
                                                        record.costPrice[index]
                                                      ) || 0)
                                                  : sum;
                                              },
                                              0
                                            );
                                          } else {
                                            totalCost =
                                              Number(record.costPrice) || 0;
                                          }

                                          const companyCurrency =
                                            this.props.sites.find(
                                              site =>
                                                site._id ===
                                                this.state.siteSelected
                                            )?.companyCurrency || 'R';

                                          // ✅ Format the number properly
                                          return `${companyCurrency} ${totalCost.toLocaleString(
                                            'en-US',
                                            {
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2
                                            }
                                          )}`;
                                        }
                                      },

                                      {
                                        title: 'Comments',
                                        dataIndex: 'costComments',
                                        key: 'costComments',
                                        render: text => {
                                          if (!text) return '';

                                          const truncatedText =
                                            text.length > 60
                                              ? `${text.substring(0, 60)}...`
                                              : text;

                                          return text.length > 60 ? (
                                            <Tooltip title={text}>
                                              <span>{truncatedText}</span>
                                            </Tooltip>
                                          ) : (
                                            <span>{text}</span>
                                          );
                                        }
                                      }
                                    ]}
                                  />
                                );
                              }
                            }}
                            columns={[
                              {
                                title: 'Day',
                                dataIndex: 'costDay',
                                key: 'costDay',
                                render: text => dayjs(text).format('DD-MM-YYYY')
                              },

                              {
                                title: 'Rooms Available',
                                dataIndex: ['totals', 'roomsAvail'],
                                key: 'roomsAvail'
                              },
                              {
                                title: 'Rooms Booked',
                                dataIndex: ['totals', 'rooms'],
                                key: 'rooms'
                              },
                              {
                                title: 'Occupancy %',
                                dataIndex: ['totals', 'occupancy'],
                                render: text => {
                                  const occupancyValue = Number(text) || 0; // ✅ Ensure a valid number
                                  return `${occupancyValue.toFixed(0)}%`; // ✅ Now `toFixed()` will work
                                }
                              },
                              {
                                title: 'PAX',
                                dataIndex: ['totals', 'pax'],
                                key: 'pax'
                              },
                              {
                                title: 'Budget',
                                dataIndex: ['totals', 'costBudget'],
                                key: 'costBudget',
                                render: text => {
                                  const companyCurrency =
                                    this.props.sites.find(
                                      site =>
                                        site._id === this.state.siteSelected
                                    )?.companyCurrency || 'R';

                                  return `${companyCurrency} ${new Intl.NumberFormat(
                                    'en-US',
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    }
                                  ).format(Number(text) || 0)}`;
                                }
                              },
                              // {
                              //   title: "Cost",
                              //   dataIndex: ["totals", "costPrice"],
                              //   key: "costPrice",
                              //   render: (text) => {
                              //     const companyCurrency = this.props.sites.find(
                              //       site => site._id === this.state.siteSelected
                              //     )?.companyCurrency || "R";

                              //     return `${companyCurrency} ${new Intl.NumberFormat('en-US', {
                              //       minimumFractionDigits: 2,
                              //       maximumFractionDigits: 2
                              //     }).format(Number(text) || 0)}`;
                              //   }
                              // },
                              {
                                title: 'Cost P/Person',
                                dataIndex: ['totals', 'costPerPerson'],
                                key: 'costPerPerson',
                                render: text => {
                                  const companyCurrency =
                                    this.props.sites.find(
                                      site =>
                                        site._id === this.state.siteSelected
                                    )?.companyCurrency || 'R';

                                  return `${companyCurrency} ${new Intl.NumberFormat(
                                    'en-US',
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    }
                                  ).format(Number(text) || 0)}`;
                                }
                              },
                              {
                                title: 'Total Cost',
                                dataIndex: ['totals', 'totalCost'],
                                key: 'totalCost',
                                render: text => {
                                  const companyCurrency =
                                    this.props.sites.find(
                                      site =>
                                        site._id === this.state.siteSelected
                                    )?.companyCurrency || 'R';

                                  return `${companyCurrency} ${new Intl.NumberFormat(
                                    'en-US',
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    }
                                  ).format(Number(text) || 0)}`;
                                }
                              },
                              {
                                title: 'Actions',
                                key: 'actions',
                                render: (_, dayRecord) => {
                                  console.log(
                                    '🟡 Editing/Deleting day row _id:',
                                    dayRecord.records[0]?._id
                                  );

                                  return (
                                    <span>
                                      <Tooltip placement="top" title="Edit Day">
                                        <EditFilled
                                          style={{
                                            backgroundColor: '#80CE90',
                                            color: 'white',
                                            padding: '0.5em',
                                            borderRadius: '3em'
                                          }}
                                          onClick={e => {
                                            e.stopPropagation(); // Prevent row click event
                                            if (!dayRecord.records[0]?._id) {
                                              console.error(
                                                '❌ Error: `_id` is undefined!'
                                              ); // 🚨 Debugging step
                                              return;
                                            }
                                            this.handleEditStockCost(
                                              dayRecord.records[0]
                                            ); // ✅ Pass the first record of the day
                                          }}
                                        />
                                      </Tooltip>
                                      <Divider type="vertical" />
                                      <Tooltip
                                        placement="top"
                                        title="Delete Day"
                                      >
                                        <DeleteFilled
                                          style={{
                                            backgroundColor: 'crimson',
                                            color: 'white',
                                            padding: '0.5em',
                                            borderRadius: '3em'
                                          }}
                                          onClick={e => {
                                            e.stopPropagation(); // Prevent row click event
                                            if (!dayRecord.records[0]?._id) {
                                              console.error(
                                                '❌ Error: `_id` is undefined!'
                                              ); // 🚨 Debugging step
                                              return;
                                            }
                                            this.setState({
                                              deleteVisible: true,
                                              deleteStock: dayRecord.records[0] // ✅ Delete day-level record
                                            });
                                          }}
                                        />
                                      </Tooltip>
                                    </span>
                                  );
                                }
                              }
                            ]}
                          />
                        )
                      }}
                      columns={[
                        {
                          title: 'Month',
                          dataIndex: 'costMonth',
                          key: 'costMonth',
                          render: text => dayjs(text).format('MMM YYYY')
                        },

                        {
                          title: 'Total Rooms Available',
                          dataIndex: ['totals', 'roomsAvail'],
                          key: 'roomsAvail'
                        },
                        {
                          title: 'Total Rooms Booked',
                          dataIndex: ['totals', 'rooms'],
                          key: 'rooms'
                        },
                        {
                          title: 'Average Occupancy %',
                          dataIndex: ['totals', 'occupancy'],
                          key: 'occupancy',
                          render: text => {
                            const occupancyValue = Number(text) || 0; // ✅ Ensure a valid number
                            return `${occupancyValue.toFixed(0)}%`; // ✅ Now `toFixed()` will work
                          }
                        },
                        {
                          title: 'Total PAX',
                          dataIndex: ['totals', 'pax'],
                          key: 'pax'
                        },
                        {
                          title: 'Cost P/Bednight',
                          dataIndex: ['totals', 'totalCostPerPAX'],
                          key: 'totalCostPerPAX',
                          render: text => {
                            const companyCurrency =
                              this.props.sites.find(
                                site => site._id === this.state.siteSelected
                              )?.companyCurrency || 'R';

                            return `${companyCurrency} ${new Intl.NumberFormat(
                              'en-US',
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              }
                            ).format(Number(text) || 0)}`;
                          }
                        },
                        {
                          title: 'Total Cost',
                          dataIndex: ['totals', 'costPrice'],
                          key: 'costPrice',
                          render: text => {
                            const companyCurrency =
                              this.props.sites.find(
                                site => site._id === this.state.siteSelected
                              )?.companyCurrency || 'R';

                            return `${companyCurrency} ${new Intl.NumberFormat(
                              'en-US',
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              }
                            ).format(Number(text) || 0)}`;
                          }
                        }
                      ]}
                    />
                  </Col>
                </Row>
              </TabPane>
            </StyledTabs>
          )}
        </Spin>
        <Modal
          title={'Delete ingredient'}
          visible={this.state.deleteVisible}
          onOk={this.handleDeleteStock}
          onCancel={this.cancelDelete}
          okText="Accept"
          cancelText="Cancel"
        >
          <span>Are you sure you want to delete this ingredient?</span>
        </Modal>
      </div>
    );
  }
}

const WrappedStock = Form.create()(Stock);
export default WrappedStock;
